import {
    AnimationStyles,
    FontWeights,
    IColumn,
    ICommandBarItemProps,
    IDropdownOption,
    IStackTokens,
    mergeStyles,
    mergeStyleSets
} from '@fluentui/react';
import { RootState } from 'app/store';
import { UpdateColumnByConfig } from 'components/controls/CustomDetailList/CustomDetailList';
import { ICustomDetailListConfiguration } from 'components/controls/CustomDetailList/ICustomDetailListConfiguration';
import { filterPredicateColumnFAM, filterPredicateColumnPropertyName, filterPredicateColumnPropertyString, onRenderColumnFAM, onRenderColumnRef, sortPredicateColumnFAM, sortPredicateColumnPropertyName, sortPredicateColumnPropertyString } from 'components/controls/Grid';
import { EControlType } from 'components/ControlWrapper';
import { IGCData } from 'global/Reducer/dataSlice';
import Formatters from 'global/Utility/Formatters';
import { ArrayToLookupByPredicate, ArrayToLookupByPredicateWithMap, dateFromOADate, formatDate, jsonClone, timestamp } from 'global/Utility/TSFunctions';
import { applyVisibility, ApplyVisibilityFields, applyVisibilityNonstandard, applyVisibilityNonstandardTemplate, BuildVisibilityScope } from 'global/Visibility/GlobalVisibility';
import { IVisibilityScope } from 'global/Visibility/IVisibilityScope.type';
import * as IXrmOptions from "model/AttributeOptionSets.type";
import { bcbs_groupconfigurationsnapshot } from 'model/AttributeOptionSets.type';
import * as IXrmTypes from "model/CRM";
import * as ICustomXrmTypes from 'model/CRM.type';
import * as FAM from 'model/FlexibleAttributeModel';
import { FlexibleFieldGenerator } from 'model/FlexibleFieldGenerator';
import { IExtendedColumn } from 'model/IExtendedColumn';
import { v4 as uuidv4 } from 'uuid';
import { ITierChange, ITierLevelChange } from 'views/TierWizard';
import { Constants } from './Constants';
import { setProcessing } from 'global/Reducer/statusSlice';
import saveAs from 'file-saver';
import { Dispatch } from 'react';
import { IApplicationContext } from './Context';
import { ValidationError } from './ValidationError';
import { EValidationSeverity, IValidationMessage } from 'components/controls/ValidationView/ValidationView.type';
import { blankSnapshot } from 'model/snapshotTemplate';

// const ignoreColumns = ['@odata.etag',
//     '_owningbusinessunit.*',
//     '_createdby_value.*',
//     'modifiedon.*',
//     '_owninguser_value.*',
//     '_modifiedby_value.*',
//     'createdon.*',
//     '_ownerid_value.*',
//     'overriddencreatedon',
//     '_modifiedonbehalfby_value',
//     'utcconversiontimezonecode',
//     '_createdonbehalfby_value',yb
//     '_owningteam_value',
//     'timezoneruleversionnumber',
//     'versionnumber@OData.*',
//     'bcbs_sortorder@OData.Community.Display.V1.FormattedValue',
//     '.*@Microsoft.Dynamics.CRM.lookuplogicalname',
//     '.*@Microsoft.Dynamics.CRM.associatednavigationproperty',
//     '.*@OData.Community.Display.V1.FormattedValue',
// ]
enum CachePolicy {
    // re
    CacheOnly,
    CacheAndUpdate,
    CacheAndUpdateDaily,
    CacheAndUpdateBackendToken
}

export const panelButtonsStyles = { root: { marginRight: 8, minWidth: '100px' } };
export const sectionStackTokens: IStackTokens = { childrenGap: 30 };
//TODO move to module construct
export const fadeIn = mergeStyles(AnimationStyles.fadeIn500, {});
export const slideRightIn400 = mergeStyles(AnimationStyles.slideRightIn40, {});
export const noOp = () => undefined;

export const appStyles = mergeStyleSets({
    button: {
        width: 130,
    },
    callout: {
        width: 450,
        maxWidth: '90%',
        padding: '20px 24px',
    },
    calloutNarrow: {
        width: 450,
        maxWidth: '90%',
        padding: '8px',
    },
    calloutCopy: {
        padding: '15px 15px',
        overflowY: 'hidden'
    },
    calloutWide: {
        width: 600,
        maxWidth: '90%',
        padding: '20px 24px',
    },
    calloutView: {
        width: 650,
    },
    calloutUltraWide: {
        width: 800,
        maxWidth: '90%',
        padding: '20px 24px',
    },
    costshareCallout: {
        width: 500,
        Height: 500,
        maxWidth: '90%',
        maxHeight: '300px',
    },
    title: {
        fontWeight: FontWeights.semilight,
        marginBottom: '5px',
        paddingTop: '4px',
        paddingBottom: '3px',
        borderBottom: '1px solid gray',
        // backgroundColor: 'rgb(0, 120, 212)',
        // backgroundColor: 'gray',
        // textAlign: 'center',
        // color: 'white',

        // backgroundColor: 'gray',
        // color: 'white',
        // padding: '5px',
        // borderRadius: '5px'

    },
    calloutContent: {
        marginBottom: 12,
        fontWeight: FontWeights.semilight,
    },
    link: {
        display: 'block',
        marginTop: 20,
    },
    cardPadding: {
        paddingInlineStart: '20px'
    }
});


export const textProp = {
    root: {
        style: {
            width: '100%',
            minHeight: '58px',
        }
    },
    label: {

    },
    textStyles: {
        root: {
            display: 'block',
            paddingTop: '4px',
            padding: '6px',
            // backgroundColor: 'rgba(128,128,128,0.05)',
            border: '1px solid lightgray',
            borderRadius: '4px',
            minHeight: '18px'
        }
    }
};


export const styleSummary: Record<string, React.CSSProperties> = {
    "dl": {
        margin: '15px',
        display: 'grid',
        gridTemplateColumns: 'auto auto',
        gap: '5px',
    },
    "dt": {
        gridColumn: 1,
        fontWeight: 680,
        textAlign: 'right',
        padding: '2px',
    },
    "dd": {
        padding: '2px',
    }
}


export const routeConstructor = () => {

}

export const friendlyValueToFlexibleFieldValue = (
    config: FAM.IGroupConfigurationConfig,
    control: EControlType,
    valueText: string,
    attribute: IXrmTypes.bcbs_config_attribute,
    masterAttribute: IXrmTypes.bcbs_config_masterattribute,
    category: IXrmTypes.bcbs_config_category | null,
    lookupValue: FAM.IEntityReferenceValue | null
) => {

    if (valueText === null) {
        return null;
    }
    else if (valueText === '(clear)') {
        return null;
    } else if (valueText === '') {
        return null;
    }

    switch (control) {
        case EControlType.text:
        case EControlType.multiText:
        case EControlType.currency:
            {
                const value: FAM.IStringValue = {
                    type: "string",
                    value: valueText
                }
                return value;
            }

        case EControlType.date:
            {

                let dateValueText = '';

                if (valueText) {
                    // TODO \d{0,4}

                    // e.g. 5/23/22 10:45 AM 
                    // e.g. 44704.44792
                    const isExcelNumber = /^\d{5}\.?\d*$/.test(valueText);

                    if (isExcelNumber) {
                        const dt = dateFromOADate(parseFloat(valueText));
                        dateValueText = formatDate(dt, 'local:yyyy-MM-dd');

                    } else {

                        const isDate = !isNaN(Date.parse(valueText));

                        if (isDate) {
                            let dateValueTextConverted = valueText;

                            const isYYYYMMDD = /^\d\d\d\d-\d\d?-\d\d?$/.test(valueText);
                            if (isYYYYMMDD) {
                                dateValueTextConverted = dateValueTextConverted + 'T00:00:00';
                            }

                            const dt = new Date(dateValueTextConverted);
                            dateValueText = formatDate(dt, 'local:yyyy-MM-dd');
                        }
                    }

                }

                if (dateValueText) {
                    const value: FAM.IDateValue = {
                        type: "date",
                        // value: ExcelDateToJSDate(eachRow[attribute.bcbs_name!]).toISOString()
                        value: dateValueText
                    }
                    return value;
                }

                return null;
            }

        case EControlType.optionset:
            {
                const optionSetId = attribute?._bcbs_config_optionsetid_value!;
                const optionSets = config.cache.map_bcbs_config_optionsetitems_bySetId[optionSetId];
                const optionSetItem = optionSets.find(q => q.bcbs_name === valueText || q.bcbs_config_optionsetitemid === valueText || q.bcbs_value?.toString() === valueText);

                if (!optionSetItem)
                    throw new Error(`Default Value for attribute(${attribute.bcbs_name}/${attribute.bcbs_config_attributeid}) for optionset with text(${valueText}) was not found for ${optionSetId}.`);

                const value: FAM.IEntityReferenceValue = {
                    type: "entity",
                    id: optionSetItem.bcbs_config_optionsetitemid!,
                    entityType: 'bcbs_config_optionsetitem',
                    name: optionSetItem.bcbs_name!,
                }
                return value;

            }

        case EControlType.boolean:
            {
                const trueValue = valueText === "Yes";
                const falseValue = valueText === "No";

                const value: FAM.IBooleanValue = {
                    type: "bool",
                    value: false
                }

                if (trueValue)
                    value.value = true;
                else if (falseValue)
                    value.value = false;
                else
                    throw new Error('expecting to receive Yes/No.');


                return value;
            }

        case EControlType.costshare:
        case EControlType.visionCostshare:
        case EControlType.pharmacyCostshare:
            {
                // cost share really requires scope/category to work, otherwise detecting by category is hard
                const map = {
                    [EControlType.visionCostshare]: config.cache.map_bcbs_config_category_named.Vision,
                    [EControlType.pharmacyCostshare]: config.cache.map_bcbs_config_category_named.Pharmacy,
                    [EControlType.costshare]: config.cache.map_bcbs_config_category_named.Medical,
                }

                const costshareCategory = map[control];

                const costShares = config.cache.map_bcbs_copaycoinoption_type[costshareCategory.bcbs_config_categoryid!];

                const costShare = costShares.find(q => q.bcbs_name === valueText || q.bcbs_copaycoinoptionid === valueText);

                if (!costShare)
                    throw new Error('Costshare not found.');

                const value: FAM.IEntityReferenceValue = {
                    type: "entity",
                    entityType: 'bcbs_copaycoinoption',
                    id: costShare.bcbs_copaycoinoptionid,
                    name: costShare.bcbs_name
                }

                return value;

            }

        case EControlType.wholeNumber:
            {
                const value: FAM.INumberValue = {
                    type: "number",
                    value: parseInt(valueText)
                }
                return value;
            }

        case EControlType.decimal:
            {
                const value: FAM.INumberValue = {
                    type: "number",
                    value: parseFloat(valueText)
                }
                return value;
            }

        case EControlType.percent:
            {
                const value: FAM.INumberValue = {
                    type: "number",
                    value: parseInt(valueText)
                }
                return value;
            }
        // todo temp fix, until I find a good solution for this
        case EControlType.lookup:
            {
                if (lookupValue)
                    return lookupValue;

                throw new Error("Lookup has not been implemented.");
            }

        default:
            return null;

    }

}


export interface IFriendlyValueOptions {
    useDecimalFormatterOnCurrency?: boolean;
}

export const friendlyValue = (control: EControlType, value: FAM.TValue, instructions?: IFriendlyValueOptions) => {

    switch (control) {
        case EControlType.text:
            return (value as FAM.IStringValue)?.value ?? "";

        case EControlType.multiText:
            return (value as FAM.IStringValue)?.value ?? "";

        case EControlType.currency:
            if ((value as FAM.INumberValue).value !== null && (value as FAM.INumberValue).value !== undefined) {
                if (instructions?.useDecimalFormatterOnCurrency)
                    return Formatters.ToDecimal((value as FAM.INumberValue).value)
                else
                    return Formatters.ToCurrencyUSD((value as FAM.INumberValue).value)
            }
            return "";

        case EControlType.date:
            return (value as FAM.IDateValue).value

        case EControlType.optionset:
            return (value as FAM.IEntityReferenceValue).name

        case EControlType.multiOptionset:
            return (value as FAM.IMultiselectOptionSetValue).value

        case EControlType.boolean:
            if ((value as FAM.IBooleanValue).value === true)
                return "Yes";
            if ((value as FAM.IBooleanValue).value === false)
                return "No";
            return "";

        case EControlType.costshare:
            return (value as FAM.IEntityReferenceValue).name;

        case EControlType.visionCostshare:
            return (value as FAM.IEntityReferenceValue).name;

        case EControlType.pharmacyCostshare:
            return (value as FAM.IEntityReferenceValue).name;

        case EControlType.wholeNumber:
            return (value as FAM.INumberValue).value?.toString();

        case EControlType.decimal:
            return (value as FAM.INumberValue).value?.toFixed(2);

        case EControlType.percent:
            return (value as FAM.INumberValue).value?.toString();

        case EControlType.lookup:
            return (value as FAM.IEntityReferenceValue).name;

        case EControlType.message:
            return "Message";

        case EControlType.attributeSet:
            return "AttributeSet";

        default:
            throw new Error("control type mapping was not available");
    }
}

export const friendlyTValue = (value: FAM.TValue) => {

    switch (value?.type) {
        case 'string':
            return (value as FAM.IStringValue)?.value ?? "";

        case 'date':
            return (value as FAM.IDateValue).value

        case 'entity':
            return (value as FAM.IEntityReferenceValue).name

        case 'multioptionset':
            return (value as FAM.IMultiselectOptionSetValue).value

        case 'bool':
            if ((value as FAM.IBooleanValue).value === true)
                return "Yes";
            if ((value as FAM.IBooleanValue).value === false)
                return "No";
            return "";

        case 'number':
            return (value as FAM.INumberValue).value?.toString();

        case 'optionset':
            return value.name;

        default:
            throw new Error("mapping was not available");
    }
}



export function ConvertToDropdownOptions(optionset: FAM.IOptionSetValue[]): IDropdownOption<FAM.IOptionSetValue>[] {
    return optionset.map(eachOption => {
        const t: IDropdownOption<FAM.IOptionSetValue> = {
            key: eachOption.value,
            text: eachOption.name,
            data: eachOption
        };

        return t;
    });
}

export function ConvertToDropdownOption(optionset: FAM.IOptionSetValue): IDropdownOption<FAM.IOptionSetValue> {
    const t: IDropdownOption<FAM.IOptionSetValue> = {
        key: optionset.value,
        text: optionset.name,
        data: optionset
    };

    return t;
}

export interface IApplicationMenuChange {
    items: ICommandBarItemProps[]
}

//TODO Alice I think we may need to simplify this
export enum EViewType {
    ViewOnly = 1,
    Modify = 2,
}

//*********** */
//TODO: ALOT HERE NEEDS TO MOVE TO dataActions, 
//TODO: all global methods should be exposed with state + dispatcher


export const createFeesAndPremiums = (state: RootState): FAM.IFeesAndPremiums => {

    const category = state.data.config.cache.map_bcbs_config_category_named['Fees and Premiums'];
    const fields = createDefaultCategoryFields(state.data.config, category, "Plan", null);

    const newFeesAndPremiums: FAM.IFeesAndPremiums = {
        id: uuidv4(),
        name: `Fees And Premium - New - ${timestamp()}`,
        fields: fields,
        attributeSets: [],
        stopLossRef: null,
        deactivated: false
    }

    return newFeesAndPremiums;
}

export const createAccountsReceivable = (
    state: RootState, name?: string
) => {

    const categoryAccountsReceivable = state.data.config.cache.map_bcbs_config_category_named['Accounts Receivable'];
    const fields = createDefaultCategoryFields(state.data.config, categoryAccountsReceivable, "Accounts Receivable", null);

    const t: FAM.IAccountsReceivable = {
        id: uuidv4(),
        name: name ?? `Accounts Receivable - New - ${timestamp()}`,
        fields: fields,
        attributeSets: [],
        deactivated: false,
    }

    return t;
}

export const createDefaultCategoryFields = (
    release: FAM.IGroupConfigurationConfig,
    category: IXrmTypes.bcbs_config_category,
    name: string,
    tierLevels: FAM.ITierLevel[] | null
) => {
    // const formDef = release.cache.categoryFormDefinitions[category.bcbs_config_categoryid!];
    const generator = new FlexibleFieldGenerator(release);
    const generateFields = generator.generateFieldsForCategoryId(category.bcbs_config_categoryid!, tierLevels);

    return generateFields;
}

export const createAttributeSet = (
    { config, json }: { config: FAM.IGroupConfigurationConfig, json: FAM.IGroupConfigurationData },
    ownerAttribute: IXrmTypes.bcbs_config_masterattribute
) => {

    const attributes = config.cache.map_bcbs_config_attribute_sets[ownerAttribute!.bcbs_config_masterattributeid!];

    const fields: FAM.IFlexibleField[] = [];

    attributes.forEach(eachAttribute => {
        const fieldSet: FAM.IFlexibleFieldValue[] = [];

        const t: FAM.IFlexibleFieldValue = {
            id: uuidv4(),
            tierRef: null,
            //TODO name? does not make sense here
            type: "primary",
            value: null,
        };

        fieldSet.push(t);

        const field: FAM.IFlexibleField = {
            configRef: { id: eachAttribute.bcbs_config_attributeid!, name: eachAttribute.bcbs_name! },
            id: uuidv4(),
            name: eachAttribute.bcbs_label!,
            masterAttributeID: eachAttribute._bcbs_config_masterattributeid_value!,
            values: fieldSet
        }

        fields.push(field);

    });

    const attributeSet: FAM.IFlexibleFieldSet = {
        name: `${ownerAttribute.bcbs_name} - New - ${timestamp()}`,
        attributeSetRef: {
            id: ownerAttribute.bcbs_config_masterattributeid!,
            name: ownerAttribute.bcbs_name!
        },
        id: uuidv4(),
        fields: fields,
        deactivated: false,
    };

    const scope = BuildVisibilityScope(
        null,
        json,
        null,
        null
    );

    ApplyVisibilityFields(config, attributeSet.fields, scope);

    return attributeSet;
}

/**
 * Clones a passed in benefit
 * @param name 
 * @param benefit 
 * @returns 
 */
export const cloneBenefit = (name: string, benefit: FAM.IBenefit) => {
    const clone: FAM.IBenefit = JSON.parse(JSON.stringify(benefit));

    //TODO: generate id for all cloned field attributes
    clone.name = name;
    clone.id = uuidv4();
    clone.status = {
        "type": "optionset",
        "name": FAM.EBenefitStatus[FAM.EBenefitStatus["In-Progress"]],
        "value": FAM.EBenefitStatus["In-Progress"]
    }

    //TODO: first build attribute model based on category and then try to populate values

    //TODO: add options parameter to allow specifying what needs to be cloned/copied (define clone rules system)

    //TODO: copy tiers
    return clone;
}

export const createPlan = (
    state: RootState,
    name: string | null,
    associatedBenefits: FAM.IBenefit[] | null,
    grandFathered: FAM.IOptionSetValue | null,
    fundingType: FAM.IOptionSetValue | null
) => {

    const category = state.data.config.cache.map_bcbs_config_category['d33bde62-d55d-ec11-8f8f-000d3a342d18'];
    const fields = createDefaultCategoryFields(state.data.config, category, "Plan", null);

    const plan: FAM.IPlan = {
        name: name ?? `Plan - New - ${timestamp()}`,
        id: uuidv4(),
        benefitRefs: [],
        feesAndPremiumsRef: null,
        grandFathered: grandFathered,
        fundingType: fundingType,
        fields: fields,
        attributeSets: [],
        nonStandards: [],
        deactivated: false,
        billingOnlyPlan: false,
    };

    associatedBenefits?.forEach(ben => {
        plan.benefitRefs.push(
            {
                id: ben.id,
                name: ben.name,
                bcbs_config_categoryid: ben.bcbs_name!,
            }
        );
    });

    return plan;
}


export const copyClonePlan = (config: FAM.IGroupConfigurationConfig, plans: FAM.IPlan[] | undefined, benefits: FAM.IBenefit[] | undefined) => {

    const planMapping = {} as any;
    const benefitMapping = {} as any;
    const ret = { plans: null as FAM.IPlan[] | null, benefits: null as FAM.IBenefit[] | null }

    const B = benefits?.map(t => {
        const newId = uuidv4();
        benefitMapping[t.id] = newId;

        return {
            ...t,
            id: newId
        } as FAM.IBenefit
    }) ?? [];

    const P = plans?.map(t => {
        const newId = uuidv4();
        planMapping[t.id] = newId;

        t.benefitRefs = t.benefitRefs.reduce(function (result, element) {
            const bId = benefitMapping[element.id];
            if (bId)
                result.push({ ...element, });
            return result;
        }, [] as FAM.IBenefitRef[]);

        return {
            ...t,
            id: newId,
        } as FAM.IPlan
    }) ?? [];

    ret.plans = P;
    ret.benefits = B;

    return ret;
}

export function nonStandardPredicate(props: {
    config?: FAM.IGroupConfigurationConfig,
    section?: IXrmTypes.bcbs_config_section,
    benefit?: FAM.IBenefit,
    groupConfiguration?: FAM.IGroupConfigurationData
}) {
    return (eachAttribute: IXrmTypes.bcbs_config_attribute) => {

        if (!eachAttribute.bcbs_nonstandard)
            return false;

        const _eachAttribute = eachAttribute as ICustomXrmTypes.Ibcbs_config_attribute_extended

        if (_eachAttribute.NonStandardCustomSections && _eachAttribute.NonStandardCustomSections[props.section?.bcbs_config_sectionid!])
            return true;

        return false;
    }
}

export const createNonStandard = (
    data: IGCData,
    scope: {
        section: IXrmTypes.bcbs_config_section,
        benefit?: FAM.IBenefit,
        groupConfiguration?: FAM.IGroupConfigurationData,
        templated?: boolean,
        name?: string, //this is for creating new NS related to templates
    }
) => {

    const generator = new FlexibleFieldGenerator(data.config);
    const fields = generator.generateNonStandardFields(scope.section.bcbs_config_sectionid!, scope?.benefit?.tiers);

    const tNew: FAM.INonStandard = {
        id: uuidv4(),
        name: scope.name ?? `Non-Standard - New - ${timestamp()}`,
        sectionRef: {
            id: scope.section.bcbs_config_sectionid!,
            name: scope.section.bcbs_name!
        },
        deactivated: false,
        fields: fields,
        referenceOnly: false,
        partOfTemplate: scope.templated ?? false,
    };
    applyVisibilityNonstandard(data.json, data.config, null, scope.benefit ?? null, tNew);

    return tNew;
}

// const xCache: Record<string, IColumn[]> = {};

/**
 * Creates non-standard columns based on the provided configuration and scope.
 * @param config - The group configuration config.
 * @param scope - The scope containing section, benefit, group configuration, config, and tier names.
 * @param gridConfig - The custom detail list configuration.
 * @param onColumnClick - The callback function for column click event.
 * @param addPredicate - The predicate function to filter fields.
 * @returns An array of extended columns representing the non-standard columns.
 */
export const createNonStandardColumns = (
    config: FAM.IGroupConfigurationConfig,
    scope: {
        section: IXrmTypes.bcbs_config_section,
        benefit?: FAM.IBenefit,
        groupConfiguration?: FAM.IGroupConfigurationData
        tierNames: Record<string, FAM.ITierLevel> | null
    },
    gridConfig?: ICustomDetailListConfiguration,
    onColumnClick?: (event: React.MouseEvent<HTMLElement, MouseEvent>, column: IColumn) => void,
    addPredicate?: (
        field?: FAM.IFlexibleField,
        configAttribute?: IXrmTypes.bcbs_config_attribute,
        configMasterAttribute?: IXrmTypes.bcbs_config_masterattribute,
    ) => boolean
) => {

    const generator = new FlexibleFieldGenerator(config);

    const fields = generator.generateNonStandardFields(scope.section.bcbs_config_sectionid!, scope?.benefit?.tiers)

    const props = scope;
    // const cached = xCache[props?.benefit?.id!];

    // if (cached)
    //     return cached;

    // const categoryNonStandards = config.cache.map_bcbs_config_category_named['Non-Standard'];

    const tNew: FAM.INonStandard = {
        id: uuidv4(),
        name: '',
        sectionRef: {
            id: scope.section.bcbs_config_sectionid!,
            name: scope.section.bcbs_name!
        },
        deactivated: false,
        fields: fields,
        referenceOnly: false,
    };

    const columns: IExtendedColumn[] = [];

    const addNameColumn = () => {

        if (addPredicate)
            if (!addPredicate({ name: 'name' } as any, undefined, undefined))
                return;

        var column: IExtendedColumn = {
            key: 'nonStandardName',
            name: 'Name',
            fieldName: 'name',
            isResizable: true,
            minWidth: 300,
            data: { bcbs_viewsortorder: 0 },
        };

        // Custom Sort Registration
        if (gridConfig) {
            column.onColumnClick = onColumnClick;
            UpdateColumnByConfig(column, gridConfig);
            column.sortPredicate = sortPredicateColumnPropertyString;
            column.filterPredicate = filterPredicateColumnPropertyString;
        }

        columns.push(column);
    }

    addNameColumn();

    tNew.fields.forEach(eachField => {

        const configAttribute = config.cache.map_bcbs_config_attribute[eachField.configRef.id];
        const configMasterAttribute = config.cache.map_bcbs_config_masterattribute[configAttribute._bcbs_config_masterattributeid_value!];

        if (!configAttribute.bcbs_viewsortorder)
            return;

        eachField.values.forEach(eachFieldValue => {

            if (addPredicate)
                if (!addPredicate(eachField, configAttribute, configMasterAttribute))
                    return;

            const column: IExtendedColumn = {
                key: `${configAttribute.bcbs_config_attributeid}-${eachFieldValue.tierRef?.id ?? ''}`,
                name: calcFieldName(eachField, eachFieldValue, configAttribute, props.tierNames),
                minWidth: configAttribute.bcbs_viewcolumnwidth ?? (configAttribute?.bcbs_name?.length ?? 10) * 8,
                fieldName: `${configAttribute.bcbs_config_attributeid}-${eachFieldValue.tierRef?.id ?? ''}`,
                data: configAttribute,
                onRender: onRenderColumnFAM(configMasterAttribute.bcbs_attributetypecode as EControlType),
                isResizable: true,
            };

            // Custom Sort Registration
            if (gridConfig) {
                column.onColumnClick = onColumnClick;
                UpdateColumnByConfig(column, gridConfig);
                column.sortPredicate = sortPredicateColumnFAM(configMasterAttribute.bcbs_attributetypecode as EControlType);
                column.filterPredicate = filterPredicateColumnFAM(configMasterAttribute.bcbs_attributetypecode as EControlType);
            }

            columns.push(column);
        });
    });

    const sorted = columns.sort((a1, a2) => a1.data.bcbs_viewsortorder! - a2.data.bcbs_viewsortorder!);

    // xCache[props.benefit?.id!] = sorted;

    return sorted;
}

export const createGroupStructureColumns = (
    config: FAM.IGroupConfigurationConfig,
    gridConfig?: ICustomDetailListConfiguration,
    onColumnClick?: (event: React.MouseEvent<HTMLElement, MouseEvent>, column: IColumn) => void,
    addPredicate?: (
        field?: FAM.IFlexibleField,
        configAttribute?: IXrmTypes.bcbs_config_attribute,
        configMasterAttribute?: IXrmTypes.bcbs_config_masterattribute,
    ) => boolean
) => {

    const columns: IExtendedColumn[] = [];

    // CES Number -------------------------------------
    {
        const column: IExtendedColumn = {
            key: 'cesNumber',
            name: 'CES Client Number',
            fieldName: 'cesNumber',
            minWidth: 120,
            isResizable: true,
        };

        if (gridConfig) {
            column.onColumnClick = onColumnClick;
            UpdateColumnByConfig(column, gridConfig);
            column.sortPredicate = sortPredicateColumnPropertyString;
            column.filterPredicate = filterPredicateColumnPropertyString;
        }

        columns.push(column);
    }

    // Group Number -------------------------------------
    {
        const column: IExtendedColumn = {
            key: 'groupNumber',
            name: 'Group Number',
            fieldName: 'groupNumber',
            minWidth: 120,
            isResizable: true
        };

        if (gridConfig) {
            column.onColumnClick = onColumnClick;
            UpdateColumnByConfig(column, gridConfig);
            column.sortPredicate = sortPredicateColumnPropertyString;
            column.filterPredicate = filterPredicateColumnPropertyString;
        }

        columns.push(column);
    }

    // Plan -------------------------------------
    {
        const column: IExtendedColumn = {
            key: 'plan',
            name: 'Plan',
            fieldName: 'planRef',
            minWidth: 120,
            isResizable: true,
            onRender: onRenderColumnRef,
        };

        if (gridConfig) {
            column.onColumnClick = onColumnClick;
            UpdateColumnByConfig(column, gridConfig);
            column.sortPredicate = sortPredicateColumnPropertyName;
            column.filterPredicate = filterPredicateColumnPropertyName;
        }

        columns.push(column);
    }

    // Accounts Receivable -------------------------------------
    {
        const column: IExtendedColumn = {
            key: 'accountsReceivable',
            name: 'Accounts Receivable',
            fieldName: 'accountsReceivableRef',
            minWidth: 120,
            isResizable: true,
            onRender: onRenderColumnRef,

        }

        if (gridConfig) {
            column.onColumnClick = onColumnClick;
            UpdateColumnByConfig(column, gridConfig);
            column.sortPredicate = sortPredicateColumnPropertyName;
            column.filterPredicate = filterPredicateColumnPropertyName;
        }

        columns.push(column);
    }

    // Stop Loss -------------------------------------
    {
        const column: IExtendedColumn = {
            key: 'stopLoss',
            name: 'Stop Loss',
            fieldName: 'stopLossRef',
            minWidth: 120,
            isResizable: true,
            onRender: onRenderColumnRef,
        }

        if (gridConfig) {
            column.onColumnClick = onColumnClick;
            UpdateColumnByConfig(column, gridConfig);
            column.sortPredicate = sortPredicateColumnPropertyName;
            column.filterPredicate = filterPredicateColumnPropertyName;
        }

        columns.push(column);
    }

    // Flexible Attributes -------------------------------------
    const generator = new FlexibleFieldGenerator(config);
    const fields = generator.generateGroupNumberFields();
    fields.forEach(eachField => {

        const configAttribute = config.cache.map_bcbs_config_attribute[eachField.configRef.id];
        const configMasterAttribute = config.cache.map_bcbs_config_masterattribute[configAttribute._bcbs_config_masterattributeid_value!];

        if (!configAttribute.bcbs_viewsortorder)
            return;

        eachField.values.forEach(eachFieldValue => {

            if (addPredicate)
                if (!addPredicate(eachField, configAttribute, configMasterAttribute))
                    return;

            const column: IExtendedColumn = {
                key: `${configAttribute.bcbs_config_attributeid}-${eachFieldValue.tierRef?.id ?? ''}`,
                name: calcFieldName(eachField, eachFieldValue, configAttribute, null),
                minWidth: configAttribute.bcbs_viewcolumnwidth ?? (configAttribute?.bcbs_name?.length ?? 10) * 8,
                fieldName: `${configAttribute.bcbs_config_attributeid}-${eachFieldValue.tierRef?.id ?? ''}`,
                data: configAttribute,
                onRender: onRenderColumnFAM(configMasterAttribute.bcbs_attributetypecode as EControlType),
                isResizable: true,
            };

            // Custom Sort Registration
            if (gridConfig) {
                column.onColumnClick = onColumnClick;
                UpdateColumnByConfig(column, gridConfig);
                column.sortPredicate = sortPredicateColumnFAM(configMasterAttribute.bcbs_attributetypecode as EControlType);
                column.filterPredicate = filterPredicateColumnFAM(configMasterAttribute.bcbs_attributetypecode as EControlType);
            }

            columns.push(column);
        });
    });

    // Status -------------------------------------
    {
        const column: IExtendedColumn = {
            key: 'status',
            name: 'Status',
            fieldName: 'status',
            minWidth: 120,
            isResizable: true,
        }

        if (gridConfig) {
            column.onColumnClick = onColumnClick;
            UpdateColumnByConfig(column, gridConfig);
            column.sortPredicate = sortPredicateColumnPropertyName;
            column.filterPredicate = filterPredicateColumnPropertyName;
        }
        columns.push(column);
    }

    return columns.sort((a1, a2) => a1.data?.bcbs_viewsortorder! - a2.data?.bcbs_viewsortorder!);

}

export const createAttributesetColumns = (
    config: FAM.IGroupConfigurationConfig,
    attributeSetId: string,
    scope: {
        tierNames: Record<string, FAM.ITierLevel> | null
    },
    gridConfig?: ICustomDetailListConfiguration,
    onColumnClick?: (event: React.MouseEvent<HTMLElement, MouseEvent>, column: IColumn) => void,
    addPredicate?: (
        field?: FAM.IFlexibleField,
        configAttribute?: IXrmTypes.bcbs_config_attribute,
        configMasterAttribute?: IXrmTypes.bcbs_config_masterattribute,
    ) => boolean
) => {

    const generator = new FlexibleFieldGenerator(config);

    const fields = generator.generateAttributeSetFields(attributeSetId);

    const props = scope;
    // const cached = xCache[props?.benefit?.id!];

    // if (cached)
    //     return cached;

    // const categoryNonStandards = config.cache.map_bcbs_config_category_named['Non-Standard'];

    const columns: IExtendedColumn[] = [];

    const addNameColumn = () => {

        if (addPredicate)
            if (!addPredicate({ name: 'name' } as any, undefined, undefined))
                return;

        const column: IExtendedColumn = {
            key: 'attributeSetName',
            name: 'Name',
            fieldName: 'name',
            isResizable: true,
            minWidth: 140,
            data: { bcbs_viewsortorder: Number.MAX_SAFE_INTEGER }
        }

        // Custom Sort Registration
        if (gridConfig) {
            column.onColumnClick = onColumnClick;
            UpdateColumnByConfig(column, gridConfig);
            column.sortPredicate = sortPredicateColumnPropertyString;
            column.filterPredicate = filterPredicateColumnPropertyString;
        }

        columns.push(column);
    }

    addNameColumn();

    fields.forEach(eachField => {

        const configAttribute = config.cache.map_bcbs_config_attribute[eachField.configRef.id];
        const configMasterAttribute = config.cache.map_bcbs_config_masterattribute[configAttribute._bcbs_config_masterattributeid_value!];

        if (!configAttribute.bcbs_viewsortorder)
            return;

        eachField.values.forEach(eachFieldValue => {

            if (addPredicate)
                if (!addPredicate(eachField, configAttribute, configMasterAttribute))
                    return;

            const column: IExtendedColumn = {
                key: `${configAttribute.bcbs_config_attributeid}-${eachFieldValue.tierRef?.id ?? ''}`,
                name: calcFieldName(eachField, eachFieldValue, configAttribute, props.tierNames),
                minWidth: configAttribute.bcbs_viewcolumnwidth ?? (configAttribute?.bcbs_name?.length ?? 10) * 8,
                fieldName: `${configAttribute.bcbs_config_attributeid}-${eachFieldValue.tierRef?.id ?? ''}`,
                data: configAttribute,
                onRender: onRenderColumnFAM(configMasterAttribute.bcbs_attributetypecode as EControlType),
                isResizable: true,
            };

            // Custom Sort Registration
            if (gridConfig) {
                column.onColumnClick = onColumnClick;
                UpdateColumnByConfig(column, gridConfig);
                column.sortPredicate = sortPredicateColumnFAM(configMasterAttribute.bcbs_attributetypecode as EControlType);
                column.filterPredicate = filterPredicateColumnFAM(configMasterAttribute.bcbs_attributetypecode as EControlType);
            }

            columns.push(column);
        });
    });

    const sorted = columns.sort((a1, a2) => a1.data.bcbs_viewsortorder! - a2.data.bcbs_viewsortorder!);

    // xCache[props.benefit?.id!] = sorted;

    return sorted;
}

export const createNonStandardGlobalColumns = (
    config: FAM.IGroupConfigurationConfig,
    scope: {
        nonStandard?: FAM.INonStandard,
        section?: IXrmTypes.bcbs_config_section,
        benefit?: FAM.IBenefit,
        groupConfiguration?: FAM.IGroupConfigurationData
        config: FAM.IGroupConfigurationConfig
        tierNames: Record<string, FAM.ITierLevel> | null
    },
    gridConfig?: ICustomDetailListConfiguration,
    onColumnClick?: (event: React.MouseEvent<HTMLElement, MouseEvent>, column: IColumn) => void,
    addPredicate?: (
        field?: FAM.IFlexibleField,
        configAttribute?: IXrmTypes.bcbs_config_attribute,
        configMasterAttribute?: IXrmTypes.bcbs_config_masterattribute,
    ) => boolean
) => {

    const generator = new FlexibleFieldGenerator(config);

    //const fields = generator.generateNonStandardFields(scope.nonStandard.sectionRef?.id!, scope?.benefit?.tiers)

    const props = scope;
    // const cached = xCache[props?.benefit?.id!];

    // if (cached)
    //     return cached;

    // const categoryNonStandards = config.cache.map_bcbs_config_category_named['Non-Standard'];

    const tNew: FAM.INonStandard = {
        id: uuidv4(),
        name: '',
        sectionRef: {
            id: scope.nonStandard?.sectionRef?.id! ?? "",
            name: scope.nonStandard?.sectionRef?.name! ?? ""
        },
        deactivated: false,
        fields: [], //fields ?? [],
        referenceOnly: false,
    };

    const columns: IExtendedColumn[] = [];

    const addColumns = () => {

        if (addPredicate)
            if (!addPredicate({ name: 'name' } as any, undefined, undefined))
                return;

        var column: IExtendedColumn = {
            key: 'nonStandardName',
            name: 'Name',
            fieldName: 'name',
            isResizable: true,
            minWidth: 300,
            data: { bcbs_viewsortorder: 0 },
        };

        var column2: IExtendedColumn = {
            key: 'partOfTemplate',
            name: 'Templated',
            fieldName: 'partOfTemplate',
            isResizable: true,
            minWidth: 100,
            data: { bcbs_viewsortorder: 0 },
        };

        var column3: IExtendedColumn = {
            key: 'categoryType',
            name: 'Category Type',
            fieldName: 'categoryType',
            isResizable: true,
            minWidth: 100,
            data: { bcbs_viewsortorder: 0 },
        };
        var column4: IExtendedColumn = {
            key: 'categoryName',
            name: 'Category Name',
            fieldName: 'categoryName',
            isResizable: true,
            minWidth: 100,
            data: { bcbs_viewsortorder: 0 },
        };
        var column5: IExtendedColumn = {
            key: 'tab',
            name: 'Tab',
            fieldName: 'tab',
            isResizable: true,
            minWidth: 100,
            data: { bcbs_viewsortorder: 0 },
        };
        var column6: IExtendedColumn = {
            key: 'section',
            name: 'Section',
            fieldName: 'section',
            isResizable: true,
            minWidth: 100,
            data: { bcbs_viewsortorder: 0 },
        };
        var column7: IExtendedColumn = {
            key: 'benefitDefition',
            name: 'Benefit Definition',
            fieldName: 'benefitDefition',
            isResizable: true,
            minWidth: 200,
            data: { bcbs_viewsortorder: 0 },
        };

        var column9: IExtendedColumn = {
            key: 'payToBenefit',
            name: 'Pay to Benefit',
            fieldName: 'payToBenefit',
            isResizable: true,
            minWidth: 100,
            data: { bcbs_viewsortorder: 0 },
        };

        // Custom Sort Registration
        if (gridConfig) {
            column.onColumnClick = onColumnClick;
            UpdateColumnByConfig(column, gridConfig);
            column.sortPredicate = sortPredicateColumnPropertyString;
            column.filterPredicate = filterPredicateColumnPropertyString;
        }
        // Custom Sort Registration
        if (gridConfig) {
            column2.onColumnClick = onColumnClick;
            UpdateColumnByConfig(column2, gridConfig);
            column2.sortPredicate = sortPredicateColumnPropertyString;
            column2.filterPredicate = filterPredicateColumnPropertyString;
        }
        // Custom Sort Registration
        if (gridConfig) {
            column3.onColumnClick = onColumnClick;
            UpdateColumnByConfig(column3, gridConfig);
            column3.sortPredicate = sortPredicateColumnPropertyString;
            column3.filterPredicate = filterPredicateColumnPropertyString;
        }
        // Custom Sort Registration
        if (gridConfig) {
            column4.onColumnClick = onColumnClick;
            UpdateColumnByConfig(column4, gridConfig);
            column4.sortPredicate = sortPredicateColumnPropertyString;
            column4.filterPredicate = filterPredicateColumnPropertyString;
        }
        // Custom Sort Registration
        if (gridConfig) {
            column5.onColumnClick = onColumnClick;
            UpdateColumnByConfig(column5, gridConfig);
            column5.sortPredicate = sortPredicateColumnPropertyString;
            column5.filterPredicate = filterPredicateColumnPropertyString;
        }
        // Custom Sort Registration
        if (gridConfig) {
            column6.onColumnClick = onColumnClick;
            UpdateColumnByConfig(column6, gridConfig);
            column6.sortPredicate = sortPredicateColumnPropertyString;
            column6.filterPredicate = filterPredicateColumnPropertyString;
        }
        // Custom Sort Registration
        if (gridConfig) {
            column7.onColumnClick = onColumnClick;
            UpdateColumnByConfig(column7, gridConfig);
            column7.sortPredicate = sortPredicateColumnPropertyString;
            column7.filterPredicate = filterPredicateColumnPropertyString;
        }
        // Custom Sort Registration
        if (gridConfig) {
            column9.onColumnClick = onColumnClick;
            UpdateColumnByConfig(column9, gridConfig);
            column9.sortPredicate = sortPredicateColumnPropertyString;
            column9.filterPredicate = filterPredicateColumnPropertyString;
        }


        columns.push(column);
        columns.push(column2);
        columns.push(column3);
        columns.push(column4);
        columns.push(column5);
        columns.push(column6);
        columns.push(column7);
        columns.push(column9);

    }

    addColumns();

    const sorted = columns.sort((a1, a2) => a1.data.bcbs_viewsortorder! - a2.data.bcbs_viewsortorder!);

    // xCache[props.benefit?.id!] = sorted;

    return sorted;
}

export const createNonStandardTemplate = (
    data: IGCData,
    scope:
        {
            id: string,
            name: string,
            category: IXrmTypes.bcbs_config_category, //this is for the field values on the template
            linkedCategory: IXrmTypes.bcbs_config_category | null, // this is what category the template is locked to
            linkedCategoryName: string | null,
            relationships?: FAM.ITemplateRelationship[]
        }
) => {
    // const categoryNonStandards = data.config.cache.map_bcbs_config_category_named['Non-Standard'];
    const generator = new FlexibleFieldGenerator(data.config);
    const fields = generator.generateFieldsForCategoryId(scope.category.bcbs_config_categoryid!);

    //check if we pass in nonstandards for link
    var relationships = [] as FAM.ITemplateRelationship[]; // i believe there is something here that will need attention as to add the non standards to the existing ones already, not to overwrite it. 

    if (scope.relationships && scope.relationships.length > 0) {
        relationships = scope.relationships;
    }

    const tNew: FAM.INonStandardTemplate = {
        id: uuidv4(),
        name: scope.name,
        fields: fields,
        linkedCategoryTypeId: scope.linkedCategory?.bcbs_config_categoryid ?? undefined,
        linkedCategoryName: scope.linkedCategoryName ?? undefined,
        sectionRef: null,
        deactivated: false,
        relationships: relationships,
    };

    applyVisibilityNonstandardTemplate(data.json, data.config, null, null, tNew);


    return tNew;
}

export const getTemplateFields = (
    data: IGCData,
    scope:
        {
            id: string,
            name: string,
            category: IXrmTypes.bcbs_config_category, //this is for the field values on the template
            linkedCategory: IXrmTypes.bcbs_config_category | null, // this is what category the template is locked to
            linkedCategoryName: string | null,
            relationships?: FAM.ITemplateRelationship[]
        }
) => {
    // const categoryNonStandards = data.config.cache.map_bcbs_config_category_named['Non-Standard'];
    const generator = new FlexibleFieldGenerator(data.config);
    const fields = generator.generateFieldsForCategoryId(scope.category.bcbs_config_categoryid!);


    //check if we pass in nonstandards for link
    var relationships = [] as FAM.ITemplateRelationship[]; // i believe there is something here that will need attention as to add the non standards to the existing ones already, not to overwrite it. 

    if (scope.relationships && scope.relationships.length > 0) {
        relationships = scope.relationships;
    }

    const tNew: FAM.INonStandardTemplate = {
        id: uuidv4(),
        name: scope.name,
        fields: fields,
        linkedCategoryTypeId: scope.linkedCategory?.bcbs_config_categoryid ?? undefined,
        linkedCategoryName: scope.linkedCategoryName ?? undefined,
        sectionRef: null,
        deactivated: false,
        relationships: relationships,
    };

    //applyVisibilityNonstandard(data.json, data.config, null, scope.benefit ?? null, tNew);

    return tNew;
}

/**
 * Creates non-standard columns based on the provided configuration and scope.
 * @param config - The group configuration config.
 * @param scope - The scope containing section, benefit, group configuration, config, and tier names.
 * @param gridConfig - The custom detail list configuration.
 * @param onColumnClick - The callback function for column click event.
 * @param addPredicate - The predicate function to filter fields.
 * @returns An array of extended columns representing the non-standard columns.
 */
export const createNonStandardTemplateColumns = (
    config: FAM.IGroupConfigurationConfig,
    scope: {
        category: IXrmTypes.bcbs_config_category
        linkedCategory: IXrmTypes.bcbs_config_category | null,
        //groupConfiguration?: FAM.IGroupConfigurationData
        config: FAM.IGroupConfigurationConfig
        //tierNames: Record<string, FAM.ITierLevel> | null
    },
    gridConfig?: ICustomDetailListConfiguration,
    onColumnClick?: (event: React.MouseEvent<HTMLElement, MouseEvent>, column: IColumn) => void,
    addPredicate?: (
        field?: FAM.IFlexibleField,
        configAttribute?: IXrmTypes.bcbs_config_attribute,
        configMasterAttribute?: IXrmTypes.bcbs_config_masterattribute,
    ) => boolean
) => {

    const generator = new FlexibleFieldGenerator(config);

    const fields = generator.generateFieldsForCategoryId(scope.category.bcbs_config_categoryid!);
    const props = scope;

    const tNew: FAM.INonStandardTemplate = {
        id: uuidv4(),
        name: '',
        linkedCategoryTypeId: scope.linkedCategory?.bcbs_config_categoryid ?? undefined,
        linkedCategoryName: scope.linkedCategory?.bcbs_name,
        sectionRef: null,
        deactivated: false,
        fields: fields,
    };

    const columns: IExtendedColumn[] = [];

    const addNameColumn = () => {

        if (addPredicate)
            if (!addPredicate({ name: 'name' } as any, undefined, undefined))
                return;

        var column: IExtendedColumn = {
            key: 'nonStandardTemplateName',
            name: 'Name',
            fieldName: 'name',
            isResizable: true,
            minWidth: 300,
            data: { bcbs_viewsortorder: 0 },
        };

        // Custom Sort Registration
        if (gridConfig) {
            column.onColumnClick = onColumnClick;
            UpdateColumnByConfig(column, gridConfig);
            column.sortPredicate = sortPredicateColumnPropertyString;
            column.filterPredicate = filterPredicateColumnPropertyString;
        }

        var column2: IExtendedColumn = {
            key: 'linkedCategoryName',
            name: 'Category Type',
            fieldName: 'linkedCategoryName',
            isResizable: true,
            minWidth: 100,
            data: { bcbs_viewsortorder: 0 },
        };

        // Custom Sort Registration
        if (gridConfig) {
            column.onColumnClick = onColumnClick;
            UpdateColumnByConfig(column, gridConfig);
            column.sortPredicate = sortPredicateColumnPropertyString;
            column.filterPredicate = filterPredicateColumnPropertyString;
        }

        columns.push(column);
        columns.push(column2);
    }

    addNameColumn();

    tNew.fields!.forEach(eachField => {

        const configAttribute = props.config.cache.map_bcbs_config_attribute[eachField.configRef.id];
        const configMasterAttribute = props.config.cache.map_bcbs_config_masterattribute[configAttribute._bcbs_config_masterattributeid_value!];

        if (!configAttribute.bcbs_viewsortorder)
            return;

        eachField.values.forEach(eachFieldValue => {

            if (addPredicate)
                if (!addPredicate(eachField, configAttribute, configMasterAttribute))
                    return;

            if (configAttribute.bcbs_config_attributeid === "cb9f16c4-710c-ef11-9f89-6045bdeb64f8")
                return; //get rid of effective date

            const column: IExtendedColumn = {
                key: `${configAttribute.bcbs_config_attributeid}-${eachFieldValue.tierRef?.id ?? ''}`,
                name: calcFieldName(eachField, eachFieldValue, configAttribute, null),
                minWidth: configAttribute.bcbs_viewcolumnwidth ?? (configAttribute?.bcbs_name?.length ?? 10) * 8,
                fieldName: `${configAttribute.bcbs_config_attributeid}-${eachFieldValue.tierRef?.id ?? ''}`,
                data: configAttribute,
                onRender: onRenderColumnFAM(configMasterAttribute.bcbs_attributetypecode as EControlType),
                isResizable: true,
            };

            // Custom Sort Registration
            if (gridConfig) {
                column.onColumnClick = onColumnClick;
                UpdateColumnByConfig(column, gridConfig);
                column.sortPredicate = sortPredicateColumnFAM(configMasterAttribute.bcbs_attributetypecode as EControlType);
                column.filterPredicate = filterPredicateColumnFAM(configMasterAttribute.bcbs_attributetypecode as EControlType);
            }

            columns.push(column);
        });
    });

    const sorted = columns.sort((a1, a2) => a1.data.bcbs_viewsortorder! - a2.data.bcbs_viewsortorder!);

    // xCache[props.benefit?.id!] = sorted;

    return sorted;
}

export const createGroupNumber = (data: IGCData) => {
    const categoryGroupNumber = data.config.cache.map_bcbs_config_category_named['Group Number'];

    let groupNumber: FAM.IGroupNumber = {
        id: uuidv4(),
        cesNumberRef: null,
        prefix: null,
        suffix: null,
        groupNumber: null,
        base: null,
        fields: createDefaultCategoryFields(data.config, categoryGroupNumber, 'Group Structure', []),
        status: data.config.cache.options_benefitStatusReasons.find(q => q.data?.value === FAM.EBenefitStatus['In-Progress'])?.data!,
        deactivated: false,
    };

    // TODO this can be improved since this can be used in bulk
    applyVisibility(data.json, data.config, undefined, { groupNumber: groupNumber });

    return groupNumber;
}

interface ICreateOpportunityProductOptionFromCRM {
    bcbs_opportunitybenefits: IXrmTypes.bcbs_opportunitybenefit[];
    bcbs_opportunityoption: IXrmTypes.bcbs_opportunityoption;
}

/**
 * Creates an opportunity product option benefit based on the provided configuration and CRM data.
 * @param config - The group configuration config object.
 * @param bcbs_quoterequest - The BCBS quote request object from CRM.
 * @param fromCRM - Optional. The data from CRM to initialize the opportunity product option benefit.
 * @param fromState - Optional/ The data from the client app state to initialize the opportunity product option benefit, acting as clone
 * @returns The created opportunity product option benefit.
 */
export const createOpportunityOptionAndBenefits = (
    config: FAM.IGroupConfigurationConfig,
    bcbs_quoterequest?: IXrmTypes.bcbs_quoterequest,
    bcbs_opportunityproduct?: IXrmTypes.bcbs_opportunityproduct,
    fromCRM?: ICreateOpportunityProductOptionFromCRM,
    fromState?: FAM.IOpportunityProductOptionBenefit,
    fromNew?: FAM.ITierDefinition,
) => {

    const convert_bcbs_opportunityoption_to_iopportunityproductoptionbenefit = (
        option: FAM.IOpportunityProductOptionBenefit,
        bcbs_opportunityoption: IXrmTypes.bcbs_opportunityoption
    ) => {

        option.bcbs_opportunityoption = bcbs_opportunityoption;

        option.id = bcbs_opportunityoption?.bcbs_opportunityoptionid!;
        option.name = bcbs_opportunityoption?.bcbs_name!;

        // fields ----
        option.bcbs_buyupuwsinglei = bcbs_opportunityoption?.bcbs_buyupuwsinglei;
        option.bcbs_buyupuwfamilyi = bcbs_opportunityoption?.bcbs_buyupuwfamilyi;
        option.bcbs_buyupuweechildreni = bcbs_opportunityoption?.bcbs_buyupuweechildreni;
        option.bcbs_buyupuweespousei = bcbs_opportunityoption?.bcbs_buyupuweespousei;
        option.bcbs_buyupuwtotali = bcbs_opportunityoption?.bcbs_buyupuwtotali;
        option.bcbs_buyupuwsinglem = bcbs_opportunityoption?.bcbs_buyupuwsinglem;
        option.bcbs_buyupuwfamilym = bcbs_opportunityoption?.bcbs_buyupuwfamilym;
        option.bcbs_buyupuweechildrenm = bcbs_opportunityoption?.bcbs_buyupuweechildrenm;
        option.bcbs_buyupuweespousem = bcbs_opportunityoption?.bcbs_buyupuweespousem;
        option.bcbs_buyupuwtotalm = bcbs_opportunityoption?.bcbs_buyupuwtotalm;
        option.bcbs_annualpremium = bcbs_opportunityoption?.bcbs_annualpremium;

        // Status ----
        option.deactivated = bcbs_opportunityoption?.statuscode === IXrmOptions.bcbs_opportunityoption.statuscode['Inactive(2)'].value
        option.won = bcbs_opportunityoption?.statuscode === IXrmOptions.bcbs_opportunityoption.statuscode['Won(808900001)'].value
        option.bcbs_tierdefinition = JSON.parse(bcbs_opportunityoption?.bcbs_tierdefinition ?? '[]');

        return option
    }

    const opportunityProductCategory = config.cache.map_bcbs_config_category_named['Quote Request'];

    const visibility = bcbs_quoterequest && bcbs_opportunityproduct
        ? VisibilityFromQuoteRequest(bcbs_quoterequest, bcbs_opportunityproduct)
        : VisibilityDefault();

    let option: FAM.IOpportunityProductOptionBenefit = {
        ...opportunityProductCategory,
        id: uuidv4(),
        name: `Option - New - ${timestamp()}`,
        deactivated: false,
        won: false,
        bcbs_tierdefinition: {
            tierSet: null,
            tierLevels: []
        },
        fields: [],
        validationMessages: [],
        visibility: visibility,
        instructions: {}
    };

    option.bcbs_opportunityproduct = bcbs_opportunityproduct;

    // from CRM record?
    if (fromCRM) {
        option.bcbs_tierdefinition = fromCRM.bcbs_opportunityoption.bcbs_tierdefinition
            ? JSON.parse(fromCRM.bcbs_opportunityoption.bcbs_tierdefinition)
            : [];

        // creating fields
        option.fields = createDefaultCategoryFields(
            config,
            opportunityProductCategory,
            'Quote Request',
            option.bcbs_tierdefinition.tierLevels,
        );

        const fieldsMap = ArrayToLookupByPredicate(option.fields, (eachField) => eachField.configRef.id);

        option = convert_bcbs_opportunityoption_to_iopportunityproductoptionbenefit(option, fromCRM.bcbs_opportunityoption);

        option.bcbs_opportunitybenefits = fromCRM.bcbs_opportunitybenefits ?? [];

        // Validation
        if (!option.bcbs_tierdefinition.tierSet) {
            option.requiresUpdate = true;
            option.validationMessages.push({
                title: "Tier Definition is Missing",
                type: EValidationSeverity.error,
                description: "Tier definition is missing, potentially resulting from record not align with the current application's requirements."
            });

            // since we found a problem, we don't want to overwrite benefits
            option.instructions.onSaveOptionBenefitsSkip = true;
        }

        // mapping benefits to fields 
        fromCRM.bcbs_opportunitybenefits?.forEach(eachBenefit => {

            // Validation
            if (eachBenefit._bcbs_config_attributeid_value === null) {
                option.validationMessages.push({
                    description: "The bcbs_config_attributeid is null, potentially resulting from a missing configuration or an unsaved record not migrated to align with the current application's requirements.",
                    title: "Config Attribute ID is Null.",
                    type: EValidationSeverity.error,
                })

                // since we found a problem, we don't want to overwrite benefits
                option.instructions.onSaveOptionSkip = true;
                option.instructions.onSaveOptionBenefitsSkip = true;
                return;
            }

            const field = fieldsMap[eachBenefit._bcbs_config_attributeid_value!];

            if (eachBenefit.bcbs_value) {
                const bcbs_value_object = JSON.parse(eachBenefit.bcbs_value!) as FAM.IFlexibleFieldValue;

                field.values.forEach((eachFieldValue, ix) => {
                    if (eachFieldValue.tierRef?.id !== bcbs_value_object.tierRef?.id)
                        return;

                    if (eachFieldValue.type !== bcbs_value_object.type)
                        return;

                    eachFieldValue.id = eachBenefit.bcbs_opportunitybenefitid ?? bcbs_value_object.id ?? uuidv4();
                    eachFieldValue.emitRefId = bcbs_value_object.emitRefId;
                    eachFieldValue.tierRef = bcbs_value_object.tierRef;
                    eachFieldValue.type = bcbs_value_object.type;
                    eachFieldValue.value = bcbs_value_object.value;
                });
            }
        });

    }
    // from client App ?
    else if (fromState) {
        option.name = fromState.name + ' - Clone';

        // TODO should we reid tiers, probably not
        const tiersByOldId: Record<string, FAM.ITierLevel> = {}

        if (fromState.bcbs_tierdefinition)
            option.bcbs_tierdefinition = jsonClone(fromState.bcbs_tierdefinition);
        else
            option.bcbs_tierdefinition = { tierLevels: [], tierSet: null };

        option.bcbs_tierdefinition.tierLevels.forEach(eachTier => {
            tiersByOldId[eachTier.id] = eachTier;
            eachTier.id = uuidv4();
        })

        // creating fields
        option.fields = createDefaultCategoryFields(
            config,
            opportunityProductCategory,
            'Quote Request',
            option.bcbs_tierdefinition.tierLevels,
        );

        const sourceFieldMap = ArrayToLookupByPredicate(fromState.fields, (eachField) => eachField.configRef.id);

        // Todo
        option.fields.forEach(eachField => {
            const sourceField = sourceFieldMap[eachField.configRef.id];

            eachField.values.forEach(eachFieldValue => {
                sourceField.values.forEach(sourceFieldValue => {
                    if (sourceFieldValue.type !== eachFieldValue.type)
                        return;

                    const newTier = tiersByOldId[sourceFieldValue.tierRef?.id!];
                    if (newTier?.id !== eachFieldValue.tierRef?.id)
                        return;

                    eachFieldValue.value = sourceFieldValue.value;

                })

            })
        })
    } else if (fromNew) {
        // new ?
        option.bcbs_tierdefinition = fromNew;

        // creating fields
        option.fields = createDefaultCategoryFields(
            config,
            opportunityProductCategory,
            'Quote Request',
            option.bcbs_tierdefinition.tierLevels,
        );
    } else {
        throw new Error("Invalid state, must provide either fromCRM, fromState, or fromNew");
    }

    // applying visibility
    ApplyVisibilityFields(config, option.fields, option.visibility);

    return option;
}


export const createGroupStructureDepartment = (config: FAM.IGroupConfigurationConfig) => {
    // todo
}

export const createBenefit = (
    config: FAM.IGroupConfigurationConfig,
    options: {
        category: IXrmTypes.bcbs_config_category,
        fundingType: FAM.IOptionSetValue<number>,
        grandFathered: FAM.IOptionSetValue<number> | null
        tiers?: {
            tiers: FAM.ITierLevel[],
            tierSetRef: FAM.IRef | null,
        }
    },
) => {
    const status = config.cache.options_benefitStatusReasons.find(q => q.data?.value === FAM.EBenefitStatus['In-Progress'])?.data!;

    const benefit: FAM.IBenefit = {
        ...structuredClone(options.category),
        id: uuidv4(),
        name: `${options.category.bcbs_name} - New - ${timestamp()}`,
        tiers: [],
        tierSetRef: null,
        fundingType: null,
        grandFathered: null,
        attributeSets: [],
        nonStandards: [],
        fields: [],
        status: structuredClone(status),
        product: null,
        deactivated: false,
    }

    if (benefit.bcbs_isfundingtypeenabled) {
        benefit.fundingType = structuredClone(options.fundingType)
    }

    if (options.grandFathered) {
        benefit.grandFathered = structuredClone(options.grandFathered);
    }

    if (options.tiers) {
        benefit.fields = createDefaultCategoryFields(config, benefit, "", options.tiers.tiers);;
        benefit.tiers = structuredClone(options.tiers.tiers);
        benefit.tierSetRef = structuredClone(options.tiers.tierSetRef);
    }

    return benefit;
}

export const createStopLoss = (
    state: RootState, name?: string
) => {
    const categoryStopLoss = state.data.config.cache.map_bcbs_config_category_named['Stop Loss'];
    const fields = createDefaultCategoryFields(state.data.config, categoryStopLoss, "Stop Loss", null);

    const t: FAM.IStopLoss = {
        id: uuidv4(),
        name: name ?? `StopLoss - New - ${timestamp()}`,
        fields: fields,
        attributeSets: [],
        deactivated: false,
    }

    return t;
}

export interface IFlexibleFieldWithAttributes {
    field: FAM.IFlexibleField;
    configAttribute: IXrmTypes.bcbs_config_attribute;
    masterAttribute: IXrmTypes.bcbs_config_masterattribute;
    controlType: EControlType,
    index: number;
}



/**
 * creates a closure by mapping fields to lookup by master attribute ID, index[0] in the array is the one that should visible and has a value
 * 
 * @param config - The group configuration config.
 * @param fields - The flexible fields.
 * @param action - Optional. The action to perform on each field. *** Maybe invoked multiple times for the same master attribute ID.
 * @returns A map of fields grouped by master attribute ID.
 */
export const FieldsToLookupByMasterAttributeId = (
    config: FAM.IGroupConfigurationConfig,
    fields: FAM.IFlexibleField[],
    action?: (field: IFlexibleFieldWithAttributes[]) => void,
) => {

    const map = fields.reduce((prev, curr, index) => {

        const configAttribute = config.cache.map_bcbs_config_attribute[curr.configRef.id];
        const masterAttribute = config.cache.map_bcbs_config_masterattribute[configAttribute._bcbs_config_masterattributeid_value!];
        const controlType = masterAttribute.bcbs_attributetypecode as EControlType;

        const keyMasterAttId = configAttribute._bcbs_config_masterattributeid_value!;
        const keyConfigAttId = configAttribute.bcbs_config_attributeid!;

        const source = prev[keyMasterAttId] ?? [];
        const isHidden = curr?.visibility ?? 0;
        const hasValue = !isHidden && curr?.values?.[0].value?.type;

        const currMapped: IFlexibleFieldWithAttributes = {
            field: curr,
            configAttribute: configAttribute,
            masterAttribute: masterAttribute,
            controlType: controlType,
            index: index,
        }

        // if invisible push to right
        if (isHidden) {
            source.push(currMapped);
        } else {
            source.unshift(currMapped);
        }

        prev[keyMasterAttId] = source;
        // prev[keyConfigAttId] = [currMapped];

        action?.(source);

        return prev;
    }, {} as Record<string, IFlexibleFieldWithAttributes[]>);

    return map;
}



/**
 * Maps fields to lookup by master attribute ID, first item in the array is the one that is visible and has a value
 * 
 * @param config - The group configuration config.
 * @param fields - The flexible fields.
 * @returns A map of fields grouped by master attribute ID.
 */
export const FieldsToLookupByConfigAttributeId = (config: FAM.IGroupConfigurationConfig, fields: FAM.IFlexibleField[]) => {

    return ArrayToLookupByPredicateWithMap(fields, (eachField) => eachField.configRef.id, (field, index) => {
        const attribute = config.cache.map_bcbs_config_attribute[field.configRef.id];
        const masterAttribute = config.cache.map_bcbs_config_masterattribute[attribute._bcbs_config_masterattributeid_value!];
        const controlType = masterAttribute.bcbs_attributetypecode as EControlType;

        const mapped: IFlexibleFieldWithAttributes = {
            field: field,
            configAttribute: attribute,
            masterAttribute: masterAttribute,
            controlType: controlType,
            index: index ?? 0,
        }

        return mapped;
    });

}


// Event System
// ---------------------------------------------------------
// This is a react anti-pattern, but really good fit for our model due to efficiency
// very simple event system,  and there are really good libraries out there that support wrapping events around command pattern
// but for now this is works, and its pretty simple
export interface ICustomEventDelegate<T> {
    eventType: string;
    details: T,
    handler: (event: CustomEvent<T>) => void;
}

export interface INewGroupConfigurationEvent extends ICustomEventDelegate<FAM.IGroupNumber | null> {
    eventType: 'NewGroupConfiguration',
}

export interface IContextExceptionEvent extends ICustomEventDelegate<unknown | null> {
    eventType: 'globalException',
}

export type TCustomEventTypes = INewGroupConfigurationEvent | IContextExceptionEvent;

export function emitCustomEvent(customEvent: Pick<TCustomEventTypes, 'eventType' | 'details'>) {
    const event = new CustomEvent<any>(customEvent.eventType, {
        detail: customEvent.details
    });

    // lets create a new one is payload is not providing one
    document.dispatchEvent(event);
}

export function subscribeCustomEvent(info: Pick<TCustomEventTypes, 'handler' | 'eventType'>) {
    const handler = info.handler as (event: Event) => void;

    document.addEventListener(info.eventType, handler);
    return () => {
        document.removeEventListener(info.eventType, handler);
    }
}

export function buildBenefitStatusOptions() {

    const options = Object.entries(FAM.EBenefitStatus)
        .filter(([key, value]) => typeof value === 'number')
        .map(([key, value]) => {

            const data: FAM.TBenefitStatusOptionSetValue = {
                //@ts-ignore
                name: key,
                type: 'optionset',
                value: value as FAM.EBenefitStatus
            }
            return data;
        })
        .map(w => {
            const option: IDropdownOption<FAM.TBenefitStatusOptionSetValue> = {
                key: w.value,
                text: w.name,
                data: w
            }
            return option;
        })

    const underWritingOption = options.find(q => q.data?.value === FAM.EBenefitStatus['Underwriting Complete']);

    if (underWritingOption)
        underWritingOption.disabled = true;

    return options;

}

export function buildGroupConfigurationStatusOptions() {

    const options = Object.entries(FAM.EGroupConfigurationStatus)
        .filter(([key, value]) => typeof value === 'number')
        .map(([key, value]) => {

            const data: FAM.TGroupConfigurationStatusOptionSetValue = {
                //@ts-ignore
                name: key,
                type: 'optionset',
                value: value as FAM.EGroupConfigurationStatus
            }
            return data;
        })
        .map(w => {
            const option: IDropdownOption<FAM.TGroupConfigurationStatusOptionSetValue> = {
                key: w.value,
                text: w.name,
                data: w
            }
            return option;
        })

    return options;

}


export function buildProductOptions() {

    const options = Object.entries(FAM.EProduct)
        .filter(([key, value]) => typeof value === 'number')
        .map(([key, value]) => {

            const data: FAM.TProductOptionSetValue = {
                //@ts-ignore
                name: key,
                type: 'optionset',
                value: value as FAM.EProduct
            }
            return data;
        })
        .map(w => {
            const option: IDropdownOption<FAM.TProductOptionSetValue> = {
                key: w.value,
                text: w.name,
                data: w
            }
            return option;
        })

    return options;

}

export function buildDeactivateOptions() {
    const options: IDropdownOption<FAM.TDeactivateOptions>[] = [];
    options.push({ key: 'Inactive', text: 'Inactive', data: { type: 'bool', value: true } })
    options.push({ key: 'active', text: 'Active', data: { type: 'bool', value: false } })
    return options;

}

export const bcbs_config_attributeid_CoverageList = [
    "f0e9b0ef-e778-ec11-8d21-000d3a35957e", // Employee Only Rate
    "f2e9b0ef-e778-ec11-8d21-000d3a35957e", // Family Rate
    "eee9b0ef-e778-ec11-8d21-000d3a35957e", // Employee + Child(ren) Rate
    "f4e9b0ef-e778-ec11-8d21-000d3a35957e", // Employee + Spouse Rate
    "f5ea81fd-528b-ec11-93b0-000d3a5c81df", // Employee + 1 (Child) Rate
    "f6e9b0ef-e778-ec11-8d21-000d3a35957e", // Two-Person Rate
    "86cc8433-538b-ec11-93b0-000d3a5c81df", // Employee + 2 Dependents Rate
    "2ceab0ef-e778-ec11-8d21-000d3a35957e"  // Concession Amount
]


export const bcbs_config_attributeid_FeeList = [
    "f0e9b0ef-e778-ec11-8d21-000d3a35957e", // Employee Only Rate
    "f2e9b0ef-e778-ec11-8d21-000d3a35957e", // Family Rate
    "eee9b0ef-e778-ec11-8d21-000d3a35957e", // Employee + Child(ren) Rate
    "f4e9b0ef-e778-ec11-8d21-000d3a35957e", // Employee + Spouse Rate
    "f5ea81fd-528b-ec11-93b0-000d3a5c81df", // Employee + 1 (Child) Rate
    "f6e9b0ef-e778-ec11-8d21-000d3a35957e", // Two-Person Rate
    "86cc8433-538b-ec11-93b0-000d3a5c81df", // Employee + 2 Dependents Rate
    "24eab0ef-e778-ec11-8d21-000d3a35957e"  // Fee Amount
]

// todo build a model on these data option sets
export const pepmFeeType = {
    "type": "entity",
    "entityType": "bcbs_config_optionsetitem",
    "id": "d34bfc88-d678-ec11-8d21-000d3a35957e",
    "name": "Per Employee Per Month (PEPM)"
}

export const pepmPerTierFeeType = {
    "type": "entity",
    "entityType": "bcbs_config_optionsetitem",
    "id": "df4bfc88-d678-ec11-8d21-000d3a35957e",
    "name": "PEPM per Tier"
}


export const sectionCoverageLevelsAndRates = 'f727d3db-d778-ec11-8d21-000d3a35957e';
export const bcbs_config_attributeid_BillGroup = '28eab0ef-e778-ec11-8d21-000d3a35957e';
export const bcbs_config_attributeid_BCCAdmin = '20eab0ef-e778-ec11-8d21-000d3a35957e';
export const bcbs_config_attributeid_FeeType = '1ceab0ef-e778-ec11-8d21-000d3a35957e';

export const masterAttributeFeeId = 'f5646443-d590-ec11-b400-0022480a93ed';

export const bcbs_config_attributeid_Bcbs_StopLossPending = '12f31c10-518d-ec11-b400-0022480a9e04';


export const calcFieldName = (
    field: FAM.IFlexibleField,
    fieldValue: FAM.IFlexibleFieldValue,
    configAttribute: IXrmTypes.bcbs_config_attribute,
    tierNames: Record<string, FAM.ITierLevel> | null
) => {
    const names: string[] = [];

    if (configAttribute.bcbs_isadvancedoption)
        names.push('💡');

    // if (props.state.data.MNIL?.value)
    //     if (configAttribute.bcbs_ismnil)
    //         names.push('(MNIL)');

    // field name:
    if (configAttribute?.bcbs_label)
        names.push(configAttribute.bcbs_label);

    // tier name : (non-in-network)
    if (tierNames && fieldValue.tierRef)
        names.push(tierNames[fieldValue.tierRef.id].name);

    if (fieldValue.type === "pcp")
        names.push("PCP");

    if (fieldValue.type === "specialist")
        names.push("Specialist");

    return names.join(' - ');
}

export const createMultiSelectOptionSetValueFromOptionGuid = (config: FAM.IGroupConfigurationConfig, optionIds: string[]) => {

    var listOfOptions: FAM.IMultiselectOptionSetValueValue[] = [];
    var newMultiSelectOptionSetValue: FAM.IMultiselectOptionSetValue = {
        type: "multioptionset",
        entityType: "bcbs_config_optionsetitem",
        value: "",//listOfNIAValues.join(","),
        options: []
    };

    optionIds.forEach(id => {
        var optionSetItem = config.cache.map_bcbs_config_optionsetitems[id];

        if (optionSetItem !== undefined) {
            var newOption: FAM.IMultiselectOptionSetValueValue =
            {
                id: id,
                name: optionSetItem.bcbs_name as string,
                value: optionSetItem.bcbs_value as number
            };
            listOfOptions.push(newOption);
        }
    })
    //Sort the list of options by name as well
    listOfOptions.sort((a, b) => a.name.localeCompare(b.name));

    newMultiSelectOptionSetValue.options = listOfOptions;

    //set the value to be alphabetical
    newMultiSelectOptionSetValue.value = listOfOptions.map(option => option.name).join(", ");

    return newMultiSelectOptionSetValue;
}

// Benefit Segments : bcbs_config_segmentid = '69d33403-a832-ec11-b6e5-0022480ab88f'
// Ancillary, COBRA, FSA, HRA, HSA, Medical, Pharmacy, Vision, Dental
export const bcbs_config_category_Benefits = [
    '5b49cc24-d63c-ec11-b6e5-0022480a9561',
    'e92df336-d63c-ec11-b6e5-0022480a9561',
    'a7605d43-d63c-ec11-b6e5-0022480a9561',
    'c884574f-d63c-ec11-b6e5-0022480a9561',
    'f9466555-d63c-ec11-b6e5-0022480a9561',
    '42ad9a7f-d63c-ec11-b6e5-0022480a9561',
    'cd48a185-d63c-ec11-b6e5-0022480a9561',
    '886aba91-d63c-ec11-b6e5-0022480a9561',
    '9ccc3835-a832-ec11-b6e5-0022480ab88f'
];

/**
 * Evaluates which snapshots to pick, when a Group Configuration Snapshot is launched for Underwriting Review.
 * @param snapshot 
 */
export const compareUnderWritingReviewTo = (state: RootState, snapshot: IXrmTypes.bcbs_groupconfigurationsnapshot) => {
    return async function (dispatch: any) {
        return compareUnderWritingReviewToWithoutDispatch(state, snapshot);
    }
}
export const compareUnderWritingReviewToWithoutDispatch = (state: RootState, snapshot: IXrmTypes.bcbs_groupconfigurationsnapshot) => {
    if (snapshot?._bcbs_uwconfirmedparentid_value)
        return state.status.snapshots?.find(s => s.bcbs_groupconfigurationsnapshotid === snapshot?._bcbs_uwconfirmedparentid_value);

    if (snapshot?.bcbs_changetypecode === bcbs_groupconfigurationsnapshot.bcbs_changetypecode["MNIL  Benefit Change Continuation(808900007)"].value
        || snapshot?.bcbs_changetypecode === bcbs_groupconfigurationsnapshot.bcbs_changetypecode["MNIL  Renewal Continuation(808900008)"].value
        || snapshot?.bcbs_changetypecode === bcbs_groupconfigurationsnapshot.bcbs_changetypecode["MNIL  Initial Setup Continuation(808900005)"].value) {
        const mnilParent = state.status.snapshots?.find(q => q.bcbs_groupconfigurationsnapshotid === snapshot._bcbs_originatingsnapshotid_value);
        if (mnilParent?._bcbs_originatingsnapshotid_value && mnilParent._bcbs_originatingsnapshot2id_value) {

            // If there are two Originating Snapshots (Merged record)
            // find the gold standards that have 'Effective Date Gold Standard' set
            // pick the one that matches current configuration effective date

            const test = state.status.snapshots?.find(q =>
                q.bcbs_iseffectivedategoldstandard === true &&
                q.bcbs_effectivedate === mnilParent.bcbs_effectivedate && // this is Date only, I think we should be fine
                q.bcbs_groupconfigurationsnapshotid !== mnilParent.bcbs_groupconfigurationsnapshotid // make sure its not the same one
            );

            return test ?? null;
        }
        else if (mnilParent?._bcbs_originatingsnapshotid_value || mnilParent?._bcbs_originatingsnapshot2id_value) {
            //If there is a single Originating Snapshot (Non-Merged record), compare the snapshot to its Originating Snapshot.

            const originSnapshotId = mnilParent?._bcbs_originatingsnapshotid_value ?? mnilParent?._bcbs_originatingsnapshot2id_value;

            const found = state.status.snapshots?.find(q => q.bcbs_groupconfigurationsnapshotid === originSnapshotId);
            return found ?? null;

        }
        return null;
    }
    if (snapshot?._bcbs_originatingsnapshotid_value && snapshot._bcbs_originatingsnapshot2id_value) {
        let test: IXrmTypes.bcbs_groupconfigurationsnapshot | null = null;
        //Check if only one is UWRC - select that one
        const urwcSnaps = state.status.snapshots?.filter(q =>
            (q.statuscode === bcbs_groupconfigurationsnapshot.statuscode['Underwriting Review Complete(2)'].value ||
                q.statuscode === bcbs_groupconfigurationsnapshot.statuscode['Gold Standard(808900006)'].value ||
                q.statuscode === bcbs_groupconfigurationsnapshot.statuscode['Retired(808900001)'].value) &&
            (q.bcbs_groupconfigurationsnapshotid === snapshot?._bcbs_originatingsnapshotid_value ||
                q.bcbs_groupconfigurationsnapshotid === snapshot._bcbs_originatingsnapshot2id_value)
        );
        if (urwcSnaps?.length === 1) {
            test = urwcSnaps[0];
        }
        //OTHERWISE

        //Do they share a parent - find that parent
        if (test === null) {
            const snap1 = state.status.snapshots?.find(b => b.bcbs_groupconfigurationsnapshotid === snapshot?._bcbs_originatingsnapshotid_value);
            const snap2 = state.status.snapshots?.find(b => b.bcbs_groupconfigurationsnapshotid === snapshot?._bcbs_originatingsnapshot2id_value);
            let testID: string | null = null;
            if (snap1?._bcbs_originatingsnapshotid_value && (snap1?._bcbs_originatingsnapshotid_value === snap2?._bcbs_originatingsnapshotid_value || snap1?._bcbs_originatingsnapshotid_value === snap2?._bcbs_originatingsnapshot2id_value))
                testID = snap1?._bcbs_originatingsnapshotid_value;
            else if (snap1?._bcbs_originatingsnapshot2id_value && (snap1?._bcbs_originatingsnapshot2id_value === snap2?._bcbs_originatingsnapshotid_value || snap1?._bcbs_originatingsnapshot2id_value === snap2?._bcbs_originatingsnapshot2id_value))
                testID = snap1?._bcbs_originatingsnapshot2id_value;
            if (testID !== null)
                test = state.status.snapshots?.find(b => b.bcbs_groupconfigurationsnapshotid === testID) ?? null;
        }
        //Next, if still none, look at grandparent snapshots. If only one is UWRC, choose it.
        if (test === null) {
            const snap1 = state.status.snapshots?.find(b => b.bcbs_groupconfigurationsnapshotid === snapshot?._bcbs_originatingsnapshotid_value);
            const snap2 = state.status.snapshots?.find(b => b.bcbs_groupconfigurationsnapshotid === snapshot?._bcbs_originatingsnapshot2id_value);

            const urwcSnaps = state.status.snapshots?.filter(q =>
                (q.statuscode === bcbs_groupconfigurationsnapshot.statuscode['Underwriting Review Complete(2)'].value ||
                    q.statuscode === bcbs_groupconfigurationsnapshot.statuscode['Gold Standard(808900006)'].value ||
                    q.statuscode === bcbs_groupconfigurationsnapshot.statuscode['Retired(808900001)'].value) &&
                (q.bcbs_groupconfigurationsnapshotid === snap1?._bcbs_originatingsnapshotid_value ||
                    q.bcbs_groupconfigurationsnapshotid === snap1?._bcbs_originatingsnapshot2id_value ||
                    q.bcbs_groupconfigurationsnapshotid === snap2?._bcbs_originatingsnapshotid_value ||
                    q.bcbs_groupconfigurationsnapshotid === snap2?._bcbs_originatingsnapshot2id_value)
            );
            if (urwcSnaps?.length === 1) {
                test = urwcSnaps[0];
            }
        }
        //OTHERWISE
        // If there are two Originating Snapshots (Merged record)
        // find the gold standards that have 'Effective Date Gold Standard' set
        // pick the one that matches current configuration effective date
        // If more than one choose newest;
        if (test === null) {
            test = state.status.snapshots?.filter(q =>
                q.bcbs_iseffectivedategoldstandard === true &&
                q.bcbs_effectivedate === snapshot.bcbs_effectivedate && // this is Date only, I think we should be fine
                q.bcbs_groupconfigurationsnapshotid !== snapshot.bcbs_groupconfigurationsnapshotid // make sure its not the same one
                && q.bcbs_effectivedate !== null
            )?.sort((a, b) => {
                return Date.parse(a.bcbs_effectivedate!) - Date.parse(b.bcbs_effectivedate!);
            })?.[0] ?? null;
        }

        return test ?? null;
    }
    else if (snapshot?._bcbs_originatingsnapshotid_value || snapshot?._bcbs_originatingsnapshot2id_value) {
        //If there is a single Originating Snapshot (Non-Merged record), compare the snapshot to its Originating Snapshot.

        const originSnapshotId = snapshot?._bcbs_originatingsnapshotid_value ?? snapshot._bcbs_originatingsnapshot2id_value;

        const found = state.status.snapshots?.find(q => q.bcbs_groupconfigurationsnapshotid === originSnapshotId);
        return found ?? null;

    }

    return null;
}

interface ILinkOption {
    id: string;
    type: "tab"
    | "section"
    | "field"
    | "plan"
    | "benefit"
    | "benefit/tab/section/field"
    | "stopLoss"
    | "accountsReceivable"
    | "claimsAR"
    | "timeline"
    | "feesAndPremium"
    | "checkList"
    | "nonstandardtemplates"
    | "checkListWithPlan";
    parent?: ILinkOption;
}
export const AppLinkTo = (
    state: RootState,
    options: ILinkOption
) => {

    let root = `/records/blueRelationship/${state.data.account?.accountid}/groupConfiguration/${state.data.snapshot.bcbs_groupconfigurationsnapshotid}`;

    if (options.parent)
        root = AppLinkTo(state, options.parent);

    switch (options.type) {
        case "tab":
            return `${root}/tab/${options.id}`;

        case "section":
            return `${root}/section/${options.id}`;

        case "field":
            return `${root}/field/${options.id}`;

        case "plan":
            return `${root}/plan/${options.id}`;

        case "stopLoss":
            return `${root}/stopLoss/${options.id}`;

        case "benefit":
            return `${root}/benefit/${options.id}`;

        case "accountsReceivable":
            return `${root}/claimsAR/${options.id}`;

        case "feesAndPremium":
            return `${root}/feesAndPremium/${options.id}`;

        case "claimsAR":
            return `${root}/claimsAR/${options.id}`;

        case "timeline":
            return `${root}/timeline`;

        case "nonstandardtemplates":
            return `${root}/nonstandardtemplates`;

        case "checkList":
            return `${root}/checklist/list`;

        case "checkListWithPlan":
            return `${root}/checklist/${options.id}`;
        default:
            return root;
    }
}

export const AppLinkToExternal = (
    options: {
        id: string | string[],
        type: "systemuser"
        | "account"
        | "opportunity"
        | "bcbs_quoterequest"
        | "bcbs_groupconfigurationsnapshot"
        | "bcbs_config_attribute"
        | "bcbs_config_masterattribute"
        | "bcbs_sbc"
        | "bcbs_bncreport"
        | "bcbs_schedulea"
        | "bcbs_carrier"
        | "customEntityType"
        | "groupLibrary"
        | "groupLibrary:bcbs_opportunityproduct"
        | 'bcbs_grouplibraryprocess'
        | 'task',
        logicalName?: string;
        extraQS?: any;
    }
) => {

    let extraQSStr = '';

    if (options.extraQS)
        for (var key in options.extraQS) {
            extraQSStr += `&${key}=${options.extraQS[key]}`;
        }

    if (extraQSStr)
        extraQSStr = "&extraqs=" + encodeURIComponent(extraQSStr.substring(1));




    switch (options.type) {
        case "systemuser":
            return `${Constants.crm.baseUrl}/main.aspx?appid=${Constants.app.crmAppId}&forceUCI=1&pagetype=entityrecord&etn=systemuser&id=${options.id}`;

        case "account":
            return `${Constants.crm.baseUrl}/main.aspx?appid=${Constants.app.crmAppId}&forceUCI=1&pagetype=entityrecord&etn=account&id=${options.id}`;

        case "opportunity":
            return `${Constants.crm.baseUrl}/main.aspx?appid=${Constants.app.crmAppId}&forceUCI=1&pagetype=entityrecord&etn=opportunity&id=${options.id}`;

        case "bcbs_quoterequest":
            return `${Constants.crm.baseUrl}/main.aspx?appid=${Constants.app.crmAppId}&forceUCI=1&pagetype=entityrecord&etn=bcbs_quoterequest&id=${options.id}`;

        case "bcbs_groupconfigurationsnapshot":
            return `${Constants.crm.baseUrl}/main.aspx?appid=${Constants.app.crmAppId}&forceUCI=1&pagetype=entityrecord&etn=bcbs_groupconfigurationsnapshot&id=${options.id}`;

        case "bcbs_config_attribute":
            return `${Constants.crm.baseUrl}/main.aspx?appid=${Constants.app.crmAppId}&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_attribute&id=${options.id}`;

        case "bcbs_config_masterattribute":
            return `${Constants.crm.baseUrl}/main.aspx?appid=${Constants.app.crmAppId}&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_masterattribute&id=${options.id}`;

        case "bcbs_sbc":
            return `${Constants.crm.baseUrl}/main.aspx?appid=${Constants.app.crmAppId}&forceUCI=1&pagetype=entityrecord&etn=bcbs_sbc&id=${options.id}`;

        case "bcbs_bncreport":
            return `${Constants.crm.baseUrl}/main.aspx?appid=${Constants.app.crmAppId}&forceUCI=1&pagetype=entityrecord&etn=bcbs_bncreport&id=${options.id}`;

        case "bcbs_schedulea":
            return `${Constants.crm.baseUrl}/main.aspx?appid=${Constants.app.crmAppId}&forceUCI=1&pagetype=entityrecord&etn=bcbs_schedulea&id=${options.id}`;

        case "customEntityType":
            return `${Constants.crm.baseUrl}/main.aspx?appid=${Constants.app.crmAppId}&forceUCI=1&pagetype=entityrecord&etn=${options.logicalName}${extraQSStr}`;

        case "bcbs_carrier":
            return `${Constants.crm.baseUrl}/main.aspx?appid=${Constants.app.crmAppId}&forceUCI=1&pagetype=entityrecord&etn=bcbs_carrier&id=${options.id}`;

        case "groupLibrary":
            return `${Constants.app.groupLibraryURL}/editor/records/blueRelationship/${options.id[0]}/groupConfiguration/${options.id[1]}${options.id[2] ? "-v" + BlobVersionToURIVersion(options.id[2]) : ""}`;

        case "groupLibrary:bcbs_opportunityproduct":
            return `${Constants.app.groupLibraryURL}/editor/bcbs_opportunityproduct/${options.id}`;

        case "bcbs_grouplibraryprocess":
            return `${Constants.crm.baseUrl}/main.aspx?appid=${Constants.app.crmAppId}&forceUCI=1&pagetype=entityrecord&etn=bcbs_grouplibraryprocess&id=${options.id}`;

        case "task":
            return `${Constants.crm.baseUrl}/main.aspx?appid=${Constants.app.crmAppId}&forceUCI=1&pagetype=entityrecord&etn=task&id=${options.id}`;

        default:
            break;
    }
}

export const BlobVersionToURIVersion = (string: string) => {
    return encodeURIComponent(string.replace(".", 'dot'));
}

export const URIVersionToBlobVersion = (string: string) => {
    return decodeURIComponent(string.replace("dot", '.'));
}


/**
 * Navigation gateway to makes a decision about state/store management and type of redirect
 * in case of internal redirect, it it used to force history reinstating
 * - Every internal navigation should run through this method
 * @param history 
 * @param state 
 * @param reason 
 */
export const AppNavigateToExternal = (history: any, state: RootState, reason: 'compareApp' | 'crm-account' | 'finished') => {
    switch (reason) {
        case 'crm-account':
            const url = AppLinkToExternal({ type: 'account', id: state.status.account?.accountid! });
            if (url)
                (window as Window).location = url;
            break;

        case 'compareApp':
            const foundSnapshot = compareUnderWritingReviewToWithoutDispatch(state, state.data.snapshot);
            (window as Window).location = (`/comparison/${state.data.account?.accountid}/${foundSnapshot?.bcbs_groupconfigurationsnapshotid ? `${foundSnapshot?.bcbs_groupconfigurationsnapshotid}/` : ""}${state.data.snapshot.bcbs_groupconfigurationsnapshotid}/`);
            break;

        case 'finished':
            history.push('/finished');

            // this does not properly work, since delay between full location reload is high...
            // (window as Window).location = ('/finished');
            break;

        default:

            break;
    }

}

export const createTierLevelFactory = (
    XRMTierLevel: IXrmTypes.bcbs_config_tierlevel,
    fromTierLevel?: FAM.ITierLevel,
    options?: {
        keep_bcbs_name?: boolean
    }
) => {

    const isCustomTier = Tier1To4.includes(XRMTierLevel.bcbs_name!);

    const t: FAM.ITierLevel = {
        ...XRMTierLevel,
        id: fromTierLevel?.id ?? uuidv4(),
        name: fromTierLevel?.name ?? (!isCustomTier ? XRMTierLevel.bcbs_name : '') ?? '',
        description: fromTierLevel?.description ?? XRMTierLevel.bcbs_name ?? '',
        pcp: fromTierLevel?.pcp ?? false,
        ion: fromTierLevel?.ion ?? XRMTierLevel.bcbs_name === 'Out of Network',
        isLabelDisabled: XRMTierLevel.bcbs_name === 'In Network' || XRMTierLevel.bcbs_name === 'Out of Network'
    };

    if (options?.keep_bcbs_name)
        if (!t.name)
            t.name = XRMTierLevel.bcbs_name!;

    return t;

}

export const createTierLevels = (
    config: FAM.IGroupConfigurationConfig,
    bcbs_config_tiersetid: string,
) => {
    const tierSet = config.tiersets.find(q => q.bcbs_config_tiersetid === bcbs_config_tiersetid)!;
    const tierLevels = config.cache.map_bcbs_config_tierlevels_by_tierSetId[tierSet.bcbs_config_tiersetid!]


    const tiers = tierLevels?.map((eachTier, index) => {
        return createTierLevelFactory(
            eachTier,
            undefined,
            {
                keep_bcbs_name: true
            },
        );
    });


    return { tierSet, tierLevels, tiers };

}


export const Tier1To4 = ['Tier 1', 'Tier 2', 'Tier 3', 'Tier 4'];


export function reconcileTiers(oldTiers: FAM.ITierLevel[], newTiers: FAM.ITierLevel[], inheritTierIdsFromOldTiers = true) {
    const swp: FAM.ITierLevel[] = [];

    const tChangeList: ITierLevelChange[] = [];
    oldTiers?.forEach(oldTier => {
        const t: ITierLevelChange = {
            isDelete: false,
            tier: oldTier,
            oldTier: oldTier,
        };
        tChangeList.push(t);

        if (Tier1To4.includes(oldTier.bcbs_name!)) {
            swp.push(oldTier);
        }

    });

    newTiers.forEach(newTier => {
        const tChange = tChangeList.find(q => q.tier.bcbs_name === newTier.bcbs_name);

        if (tChange) {

            tChange.newTier = newTier;
            tChange.tier = newTier;

            if (Tier1To4.includes(newTier.bcbs_name!)) {
                tChange.oldTierOptions = swp;
            }

        } else {
            const t: ITierLevelChange = {
                isDelete: false,
                isNew: true,
                tier: newTier,
                newTier: newTier,
            };

            tChangeList.push(t);
        }

    });

    // data sync between tiers
    // ------------------------
    tChangeList.forEach(eChange => {

        if (!eChange.newTier)
            eChange.isDelete = true;

        // if successfully mapped, try using same tier ids
        if (inheritTierIdsFromOldTiers)
            if (eChange.oldTier && eChange.newTier)
                eChange.newTier.id = eChange.oldTier?.id;
    });

    // Comprehensive - In Network mapping
    // ------------------------
    const oldComprehensive = tChangeList.find(q => q.oldTier?.bcbs_name === 'Comprehensive');
    const newComprehensive = tChangeList.find(q => q.newTier?.bcbs_name === 'Comprehensive');
    const oldInNetwork = tChangeList.find(q => q.oldTier?.bcbs_name === 'In Network');
    const newInNetwork = tChangeList.find(q => q.newTier?.bcbs_name === 'In Network');

    if (newComprehensive && oldInNetwork) {
        newComprehensive.oldTier = oldInNetwork.oldTier;
        // oldInNetwork.newTier = newComprehensive.newTier;
    }

    if (oldComprehensive && newInNetwork) {
        newInNetwork.oldTier = oldComprehensive.oldTier;
    }


    // ------------------------
    const mapSorted = tChangeList.sort((a, b) => (a?.tier?.bcbs_sortorder ?? 0) - (b?.tier?.bcbs_sortorder ?? 0));
    return mapSorted;
}

export const reconcileFields = (
    newFields: FAM.IFlexibleField[],
    oldFields: FAM.IFlexibleField[],
    tierChange: ITierChange,
    config: FAM.IGroupConfigurationConfig
) => {


    // * try to use same field id
    // value id also good to copy (include id, and everything)
    // Scenarios:
    // - Not Tiered -> 
    // - Comprehensive -> Comprehensive
    // - Comprehensive -> InNtw/OutNtw
    // - Comprehensive -> InNtw/OutNtw + Tiers
    // - InNtw/OutNtw -> Comprehensive
    // - InNtw/OutNtw + Tiers -> Comprehensive
    // - InNtw/OutNtw -> Comprehensive
    // - X -> X
    // configId > Field
    const oldFieldsLookup: Record<string, FAM.IFlexibleField> = {};
    oldFields.forEach(t => {
        oldFieldsLookup[t.configRef.id] = t;
    });

    newFields.forEach(newField => {
        const oldField = oldFieldsLookup[newField.configRef.id];

        if (oldField && oldField.values && oldField.values.length > 0) {
            // if field is not tiered:
            // * new value should also not be tiered
            // * copy as is
            // we dont care about pcp/specialist
            if (!oldField.values[0].tierRef) {
                newField.values = oldField.values;
                return;
            }

            // if field is tiered:
            newField.values.forEach(newValue => {

                const map = tierChange.tierChanges.find(q => q.newTier?.id === newValue.tierRef?.id);
                if (map) {

                    // ok we are deleting this, so ignore ...
                    if (map.isDelete)
                        return;

                    // field has been mapped
                    if (map.oldTier?.id && map.newTier?.id) {

                        // TODO PCP/Specialist
                        // scenarios:
                        // 1) Primary <- PCP+Specialist
                        // map Primary from PCP
                        // 2) PCP+Specialist <- Primary
                        // - map PCP from primary
                        // 3) PCP+Specialist -> PCP+Specialist
                        // - map PCP from PCP and Specialist from Specialist
                        if (newValue.type === 'pcp') {

                            const oldFieldValue = oldField.values.find(q => q.tierRef?.id === map.oldTier!.id && q.type === 'pcp');

                            if (oldFieldValue) {
                                newValue.value = oldFieldValue.value;
                            } else {
                                const oldFieldValue = oldField.values.find(q => q.tierRef?.id === map.oldTier!.id && q.type === 'primary');

                                if (oldFieldValue)
                                    newValue.value = oldFieldValue.value;
                            }
                        }
                        else if (newValue.type === 'specialist') {

                            const oldFieldValue = oldField.values.find(q => q.tierRef?.id === map.oldTier!.id && q.type === 'specialist');

                            if (oldFieldValue)
                                newValue.value = oldFieldValue.value;

                        }
                        else if (newValue.type === 'primary') {

                            const oldFieldValue = oldField.values.find(q => q.tierRef?.id === map.oldTier!.id && q.type === 'primary');

                            if (oldFieldValue) {
                                newValue.value = oldFieldValue.value;
                            }
                            else {

                                const oldFieldValue = oldField.values.find(q => q.tierRef?.id === map.oldTier!.id && q.type === 'pcp');

                                if (oldFieldValue)
                                    newValue.value = oldFieldValue.value;

                            }
                        }

                    }

                }
            });

        }

    });

    return {
        fields: newFields,
        tierSet: tierChange.tierSet,
    };
}

export const reconcileBenefit = (
    benefit: FAM.IBenefit,
    tierChange: ITierChange,
    config: FAM.IGroupConfigurationConfig,
    allowLevelChange = true
) => {


    const _tiers: FAM.ITierLevel[] = [];

    // lets grab good tiers from requested change
    tierChange.tierChanges.forEach(t => {

        // if (t.isDelete)
        //     if (allowLevelChange)
        //         return;

        // if (t.isNew)
        //     if (!allowLevelChange)
        //         return;

        if (t.isDelete)
            return;

        _tiers.push(t.tier);
    });

    const benefitCategory = config.cache.map_bcbs_config_category[benefit.bcbs_config_categoryid!];
    const _fields = createDefaultCategoryFields(config,
        benefitCategory,
        benefit.name,
        _tiers
    );

    const changes = reconcileFields(
        _fields,
        benefit.fields,
        tierChange,
        config
    );

    // const categoryNonStandards = config.cache.map_bcbs_config_category_named['Non-Standard'];

    benefit.nonStandards.forEach(eachNS => {

        const generator = new FlexibleFieldGenerator(config);
        const _fields = generator.generateNonStandardFields(eachNS.sectionRef?.id!, _tiers)

        reconcileFields(
            _fields,
            eachNS.fields,
            tierChange,
            config
        );

        eachNS.fields = _fields;

    });

    benefit.fields = changes.fields;
    benefit.tiers = _tiers;
    benefit.tierSetRef = {
        id: changes.tierSet?.bcbs_config_tiersetid!,
        name: changes.tierSet?.bcbs_name!,
    }
}


export const suggestNewCESNumber = (cesNumbers: FAM.ICESNumber[]) => {

    let lastDigit = 1;

    if (cesNumbers.length > 0)
        lastDigit = cesNumbers.reduce((prev, curr) => {
            const parsedPlaceHolder = curr.cesNumber?.match(/(?:<Place Holder\s)(\d+)>/);

            if (parsedPlaceHolder?.length === 2) {
                const placeHolderDigit = parseInt(parsedPlaceHolder[1]) + 1;

                if (placeHolderDigit > prev)
                    return placeHolderDigit;
            }
            return prev;
        }, 1);

    const data: FAM.ICESNumber = {
        id: uuidv4(),
        cesNumber: `<Place Holder ${lastDigit}>`,
        deactivated: false,
    };

    return data;
}



interface ICancellationFields {
    [key: string]: {
        "CategoryName": string;
        "Run Out Claims End Date": string;
        "Pay Run Out Claims How Many Months": string;
        "Cancellation Effective Date": string;
    };
}



export const CancellationFieldsByCategory: ICancellationFields = {

    "4f432ecf-bc5d-ec11-8f8f-000d3a342d18": {
        "CategoryName": "Group Configuration",
        "Run Out Claims End Date": "f9a36909-d05d-ec11-8f8f-000d3a5a062b",
        "Pay Run Out Claims How Many Months": "34a46909-d05d-ec11-8f8f-000d3a5a062b",
        "Cancellation Effective Date": "36a46909-d05d-ec11-8f8f-000d3a5a062b"
    },
    "23153cda-d08d-ec11-b400-0022480b6b1d": {
        "CategoryName": "Group Number",
        "Run Out Claims End Date": "c27c1bc6-d18d-ec11-b400-0022480a93ed",
        "Pay Run Out Claims How Many Months": "d47c1bc6-d18d-ec11-b400-0022480a93ed",
        "Cancellation Effective Date": "d67c1bc6-d18d-ec11-b400-0022480a93ed"
    },
    "42ad9a7f-d63c-ec11-b6e5-0022480a9561": {
        "CategoryName": "Medical",
        "Cancellation Effective Date": "c9a8fddf-52a3-ec11-9840-0022480b1a5e",
        "Pay Run Out Claims How Many Months": "cda8fddf-52a3-ec11-9840-0022480b1a5e",
        "Run Out Claims End Date": "cfa8fddf-52a3-ec11-9840-0022480b1a5e"
    },
    "9ccc3835-a832-ec11-b6e5-0022480ab88f": {
        "CategoryName": "Dental",
        "Cancellation Effective Date": "d1a8fddf-52a3-ec11-9840-0022480b1a5e",
        "Pay Run Out Claims How Many Months": "d5a8fddf-52a3-ec11-9840-0022480b1a5e",
        "Run Out Claims End Date": "d7a8fddf-52a3-ec11-9840-0022480b1a5e"
    },
    "886aba91-d63c-ec11-b6e5-0022480a9561": {
        "CategoryName": "Vision",
        "Cancellation Effective Date": "d9a8fddf-52a3-ec11-9840-0022480b1a5e",
        "Pay Run Out Claims How Many Months": "dda8fddf-52a3-ec11-9840-0022480b1a5e",
        "Run Out Claims End Date": "dfa8fddf-52a3-ec11-9840-0022480b1a5e"
    },
    "cd48a185-d63c-ec11-b6e5-0022480a9561": {
        "CategoryName": "Pharmacy",
        "Cancellation Effective Date": "e1a8fddf-52a3-ec11-9840-0022480b1a5e",
        "Pay Run Out Claims How Many Months": "e5a8fddf-52a3-ec11-9840-0022480b1a5e",
        "Run Out Claims End Date": "e7a8fddf-52a3-ec11-9840-0022480b1a5e"
    },
    "e92df336-d63c-ec11-b6e5-0022480a9561": {
        "CategoryName": "COBRA",
        "Cancellation Effective Date": "e9a8fddf-52a3-ec11-9840-0022480b1a5e",
        'Pay Run Out Claims How Many Months': '',
        "Run Out Claims End Date": ''
    },
    "c884574f-d63c-ec11-b6e5-0022480a9561": {
        "CategoryName": "HRA",
        "Cancellation Effective Date": '9232a33f-548d-ec11-b400-0022480a90e0',
        "Run Out Claims End Date": 'a032a33f-548d-ec11-b400-0022480a90e0',
        "Pay Run Out Claims How Many Months": '9632a33f-548d-ec11-b400-0022480a90e0',
    },
    // "a7605d43-d63c-ec11-b6e5-0022480a9561": {
    //     "CategoryName": "FSA",
    //     "Run Out Claims End Date": '7ffbb77c-578d-ec11-b400-0022480a90e0',
    //     "Cancellation Effective Date": '6ffbb77c-578d-ec11-b400-0022480a90e0',
    //     "Pay Run Out Claims How Many Months": '9632a33f-548d-ec11-b400-0022480a90e0',
    // }
    // "9d86ede9-2a53-ee11-be6f-000d3a305861": {
    //     "CategoryName": "LSA",
    //     "Cancellation Effective Date": 'cf8d55bd-d253-ee11-be6f-000d3a305861',
    //     "Pay Run Out Claims How Many Months": '',
    //     "Run Out Claims End Date": ''
    // }


}

export function isBaseAdminQuoteTypeCode(bcbs_quotetypecode?: number) {
    const useBaseAdmin =
        bcbs_quotetypecode === IXrmOptions.bcbs_opportunityproduct.bcbs_quotetypecode['Administrative Services Only(808900000)'].value ||
        bcbs_quotetypecode === IXrmOptions.bcbs_opportunityproduct.bcbs_quotetypecode['ASO with Stop Loss(808900001)'].value ||
        bcbs_quotetypecode === IXrmOptions.bcbs_opportunityproduct.bcbs_quotetypecode['National Alliance(808900003)'].value

    return useBaseAdmin;
}

export async function DetailListExcelGenerationAsync(
    dispatch: Dispatch<any>,
    state: RootState,
    application: IApplicationContext,
    columns: IColumn[],
    items: any[]
) {
    console.table(items);
    console.table(columns);
    try {
        dispatch(setProcessing(true));
        const excelExtractImport = await import("global/ExcelExtract")
        const { DetailListExcelGeneration } = excelExtractImport;
        const result = await DetailListExcelGeneration(
            state,
            application.dataSource,
            columns as any,
            items,
        )
        const fileName = `Extract-${new Date().getTime()}.xlsx`;
        saveAs(result.file, fileName);
    } catch (error) {
        emitCustomEvent({
            eventType: 'globalException',
            details: error
        });
    } finally {
        dispatch(setProcessing(false));
    }
}

export const VisibilityDefault = () => {
    const visibility: IVisibilityScope = {
        effectiveDate: 0,
        operativeDate: 0,
        erisa: null,
        fundingType: null,
        grandFathered: null,
        lineOfBusiness: null,
        product: false,
    };

    return visibility;
}

export const VisibilityFromQuoteRequest = (
    bcbs_quoterequest: IXrmTypes.bcbs_quoterequest,
    bcbs_opportunityproduct: IXrmTypes.bcbs_opportunityproduct,
) => {
    const visibility = VisibilityDefault();

    if (bcbs_opportunityproduct && bcbs_opportunityproduct.bcbs_quotetypecode) {
        const map: Record<number, number> = {}

        map[IXrmOptions.bcbs_opportunityproduct.bcbs_quotetypecode['ASO with Stop Loss(808900001)'].value] = IXrmOptions.bcbs_groupconfigurationsnapshot.bcbs_fundingtypecode['ASO with Stop Loss(808900001)'].value;
        map[IXrmOptions.bcbs_opportunityproduct.bcbs_quotetypecode['Administrative Services Only(808900000)'].value] = IXrmOptions.bcbs_groupconfigurationsnapshot.bcbs_fundingtypecode['Administrative Services Only(808900000)'].value;
        map[IXrmOptions.bcbs_opportunityproduct.bcbs_quotetypecode['Fully Insured(808900002)'].value] = IXrmOptions.bcbs_groupconfigurationsnapshot.bcbs_fundingtypecode['Fully Insured(808900002)'].value;
        map[IXrmOptions.bcbs_opportunityproduct.bcbs_quotetypecode['Level Funded(808900004)'].value] = IXrmOptions.bcbs_groupconfigurationsnapshot.bcbs_fundingtypecode['Level Funded(808900004)'].value;
        map[IXrmOptions.bcbs_opportunityproduct.bcbs_quotetypecode['National Alliance(808900003)'].value] = IXrmOptions.bcbs_groupconfigurationsnapshot.bcbs_fundingtypecode['National Alliance(808900003)'].value;

        visibility.fundingType = map[bcbs_opportunityproduct.bcbs_quotetypecode] ?? null;
    }

    if (bcbs_quoterequest?.bcbs_effectivedate)
        visibility.effectiveDate = new Date(bcbs_quoterequest.bcbs_effectivedate).getTime();

    if (bcbs_quoterequest?.createdon)
        visibility.operativeDate = new Date(bcbs_quoterequest.createdon).getTime();

    return visibility;
}

export function CreateSnapshotFromOption(state: RootState, optionBenefit: FAM.IOpportunityProductOptionBenefit) {
    const snapshot = blankSnapshot()
    return snapshot;
}
